/**
 * @license ngx-ui-scroll
 * MIT license
 */

import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Component, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, Directive, Input, TemplateRef, ViewContainerRef, ComponentFactoryResolver, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["ui-scroll", ""];
function UiScrollComponent_div_1_ng_template_1_Template(rf, ctx) { }
const _c1 = function (a0, a1, a2, a3) { return { $implicit: a0, index: a1, odd: a2, even: a3 }; };
function UiScrollComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, UiScrollComponent_div_1_ng_template_1_Template, 0, 0, "ng-template", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("position", item_r1.invisible ? "fixed" : null)("left", item_r1.invisible ? "-99999px" : null);
    ɵngcc0.ɵɵattribute("data-sid", item_r1.nodeId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(7, _c1, item_r1.data, item_r1.$index, item_r1.$index % 2, !(item_r1.$index % 2)));
} }
const checkDatasource = (datasource) => {
    if (!datasource) { // also handles null case
        throw new Error('No datasource provided');
    }
    if (!(typeof datasource === 'object')) {
        throw new Error('Datasource is not an object');
    }
    if (!('get' in datasource)) {
        throw new Error('Datasource get method is not implemented');
    }
    if (typeof datasource.get !== 'function') {
        throw new Error('Datasource get is not a function');
    }
    if ((((/** @type {?} */ (datasource.get)))).length < 2) {
        throw new Error('Datasource get method invalid signature');
    }
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const assignBoolean = (target, source, token, defaults) => {
    /** @type {?} */
    const param = source[token];
    if (typeof param === 'undefined') {
        return;
    }
    if (typeof param !== 'boolean') {
        console.warn(token + ' setting parse error, set it to ' + (defaults)[token] + ' (default)');
        return;
    }
    target[token] = param;
    return true;
};
/** @type {?} */
const assignNumeric = (target, source, token, defaults, integer = false) => {
    /** @type {?} */
    const param = source[token];
    if (typeof param === 'undefined') {
        return;
    }
    if (typeof param !== 'number') {
        console.warn(token + ' setting parse error, set it to ' + defaults[token] + ' (default)');
        return;
    }
    if (integer && parseInt(param.toString(), 10) !== param) {
        console.warn(token + ' setting parse error, set it to ' + defaults[token] + ' (default)');
        return;
    }
    target[token] = param;
    return true;
};
/** @type {?} */
const assignMinimalNumeric = (target, source, token, defaults, minSettings, integer = false, mustExist = true) => {
    if (assignNumeric(target, source, token, defaults, integer) !== true) {
        if (!mustExist) {
            return;
        }
    }
    if (target[token] < minSettings[token]) {
        console.warn(token + ' setting is less than minimum, set it to ' + minSettings[token]);
        target[token] = minSettings[token];
        return;
    }
    return true;
};
/** @type {?} */
const assignCommon = (target, settings, defaults) => {
    Object.assign(target, defaults);
    if (typeof settings === 'undefined') {
        return;
    }
    if (typeof settings !== 'object') {
        console.warn('settings is not an object, fallback to the defaults');
        return;
    }
};
/** @type {?} */
const assignSettings = (target, settings, defaults, minSettings) => {
    assignCommon(target, settings, defaults);
    assignBoolean(target, settings, 'adapter', defaults);
    assignNumeric(target, settings, 'startIndex', defaults);
    assignNumeric(target, settings, 'minIndex', defaults);
    assignNumeric(target, settings, 'maxIndex', defaults);
    assignMinimalNumeric(target, settings, 'itemSize', defaults, minSettings, true, false);
    assignMinimalNumeric(target, settings, 'bufferSize', defaults, minSettings, true);
    assignMinimalNumeric(target, settings, 'padding', defaults, minSettings);
    assignBoolean(target, settings, 'infinite', defaults);
    assignBoolean(target, settings, 'horizontal', defaults);
    assignBoolean(target, settings, 'windowViewport', defaults);
    assignBoolean(target, settings, 'inverse', defaults);
};
/** @type {?} */
const assignDevSettings = (target, devSettings, defaults, minDevSettings) => {
    assignCommon(target, devSettings, defaults);
    assignBoolean(target, devSettings, 'debug', defaults);
    assignBoolean(target, devSettings, 'immediateLog', defaults);
    assignBoolean(target, devSettings, 'logTime', defaults);
    assignBoolean(target, devSettings, 'logProcessRun', defaults);
    assignMinimalNumeric(target, devSettings, 'throttle', defaults, minDevSettings, true);
    assignMinimalNumeric(target, devSettings, 'initDelay', defaults, minDevSettings, true);
    assignMinimalNumeric(target, devSettings, 'initWindowDelay', defaults, minDevSettings, true);
    assignBoolean(target, devSettings, 'changeOverflow', defaults);
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {number} */
const AdapterPropType = {
    Scalar: 0,
    Function: 1,
    Observable: 2,
};
AdapterPropType[AdapterPropType.Scalar] = 'Scalar';
AdapterPropType[AdapterPropType.Function] = 'Function';
AdapterPropType[AdapterPropType.Observable] = 'Observable';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const Direction = {
    forward: 'forward',
    backward: 'backward',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const Process = {
    init: 'init',
    scroll: 'scroll',
    reset: 'adapter.reset',
    reload: 'adapter.reload',
    append: 'adapter.append',
    prepend: 'adapter.prepend',
    check: 'adapter.check',
    remove: 'adapter.remove',
    userClip: 'adapter.clip',
    insert: 'adapter.insert',
    fix: 'adapter.fix',
    start: 'start',
    preFetch: 'preFetch',
    fetch: 'fetch',
    postFetch: 'postFetch',
    render: 'render',
    preClip: 'preClip',
    clip: 'clip',
    adjust: 'adjust',
    end: 'end',
};
/** @enum {string} */
const ProcessStatus = {
    start: 'start',
    next: 'next',
    done: 'done',
    error: 'error',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @enum {string} */
const ValidatorType = {
    mandatory: 'must be present',
    integer: 'must be an integer',
    integerUnlimited: 'must be an integer or infinity',
    itemList: 'must be an array of items',
    boolean: 'must be a boolean',
    object: 'must be an object',
    function: 'must be a function',
    funcOfxArguments: 'must have arg1 arguments',
    funcOfxAndMoreArguments: 'must have at least arg1 arguments',
    oneOfCan: 'can be present only if none of arg1 list is present',
    oneOfMust: 'must be present if none of arg1 list is present',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const getNumber = (value) => value === '' || value === null ? NaN : Number(value);
/** @type {?} */
const onMandatory = (value) => {
    /** @type {?} */
    const isValid = typeof value !== 'undefined';
    return { value: value, isSet: false, isValid, errors: isValid ? [] : [
            'must be present'
        ] };
};
/** @type {?} */
const onInteger = (value) => {
    /** @type {?} */
    let parsedValue = value;
    /** @type {?} */
    const errors = [];
    value = getNumber(value);
    parsedValue = parseInt(value, 10);
    if (value !== parsedValue) {
        errors.push('must be an integer');
    }
    return { value: parsedValue, isSet: true, isValid: !errors.length, errors };
};
/** @type {?} */
const onIntegerUnlimited = (value) => {
    /** @type {?} */
    let parsedValue = value;
    /** @type {?} */
    const errors = [];
    value = getNumber(value);
    if (value === Infinity || value === -Infinity) {
        parsedValue = value;
    }
    else {
        parsedValue = parseInt(value, 10);
    }
    if (value !== parsedValue) {
        errors.push('must be an integer or +/- Infinity');
    }
    return { value: parsedValue, isSet: true, isValid: !errors.length, errors };
};
/** @type {?} */
const onBoolean = (value) => {
    return { value: !!value, isSet: true, isValid: true, errors: [] };
};
/** @type {?} */
const onObject = (value) => {
    /** @type {?} */
    const errors = [];
    if (typeof value !== 'object') {
        errors.push('must be an object');
    }
    return { value, isSet: true, isValid: !errors.length, errors };
};
/** @type {?} */
const onItemList = (value) => {
    /** @type {?} */
    let parsedValue = value;
    /** @type {?} */
    const errors = [];
    if (!Array.isArray(value)) {
        errors.push('must be an array');
        parsedValue = [];
    }
    else if (!value.length) {
        errors.push('must be an array with at least 1 item');
    }
    else if (value.length > 1) {
        /** @type {?} */
        const type = typeof value[0];
        if (value.some((v) => typeof v !== type)) {
            errors.push('must be an array of items of the same type');
        }
    }
    return { value: parsedValue, isSet: true, isValid: !errors.length, errors };
};
/** @type {?} */
const onFunction = (value) => {
    /** @type {?} */
    const errors = [];
    if (typeof value !== 'function') {
        errors.push('must be a function');
    }
    return { value, isSet: true, isValid: !errors.length, errors };
};
/** @type {?} */
const onFunctionWithXArguments = (argsCount) => (value) => {
    /** @type {?} */
    const result = onFunction(value);
    if (!result.isValid) {
        return result;
    }
    value = result.value;
    /** @type {?} */
    const errors = [];
    if (((/** @type {?} */ (value))).length !== argsCount) {
        errors.push(`must have ${argsCount} argument` + (argsCount > 1 ? 's' : ''));
    }
    return { value, isSet: true, isValid: !errors.length, errors };
};
/** @type {?} */
const onFunctionWithXAndMoreArguments = (argsCount) => (value) => {
    /** @type {?} */
    const result = onFunction(value);
    if (!result.isValid) {
        return result;
    }
    value = result.value;
    /** @type {?} */
    const errors = [];
    if (((/** @type {?} */ (value))).length < argsCount) {
        errors.push(`must have at least ${argsCount} argument` + (argsCount > 1 ? 's' : ''));
    }
    return { value, isSet: true, isValid: !errors.length, errors };
};
/** @type {?} */
const onOneOf = (tokens, must) => (value, context) => {
    /** @type {?} */
    const errors = [];
    /** @type {?} */
    const isSet = typeof value !== 'undefined';
    /** @type {?} */
    let noOneIsPresent = !isSet;
    if (!Array.isArray(tokens) || !tokens.length) {
        errors.push(`token list must be passed`);
    }
    else {
        for (let i = tokens.length - 1; i >= 0; i--) {
            /** @type {?} */
            const token = tokens[i];
            if (typeof token !== 'string') {
                errors.push(`token list must be an array of strings`);
                break;
            }
            /** @type {?} */
            const isAnotherPresent = context.hasOwnProperty(token);
            if (isSet && isAnotherPresent) {
                errors.push(`must not be present with "${token}"`);
                break;
            }
            if (noOneIsPresent && isAnotherPresent) {
                noOneIsPresent = false;
            }
        }
        if (must && noOneIsPresent) {
            errors.push(`must be present (or "${tokens.join('", "')}" must be present)`);
        }
    }
    return { value, isSet, isValid: !errors.length, errors };
};
const ɵ11 = (count) => ({
    type: ValidatorType.funcOfxArguments,
    method: onFunctionWithXArguments(count)
}), ɵ12 = (count) => ({
    type: ValidatorType.funcOfxAndMoreArguments,
    method: onFunctionWithXAndMoreArguments(count)
}), ɵ13 = (list) => ({
    type: ValidatorType.oneOfCan,
    method: onOneOf(list, false)
}), ɵ14 = (params) => ({
    type: ValidatorType.oneOfMust,
    method: onOneOf(params, true)
});
/** @type {?} */
const VALIDATORS = {
    MANDATORY: {
        type: ValidatorType.mandatory,
        method: onMandatory
    },
    INTEGER: {
        type: ValidatorType.integer,
        method: onInteger
    },
    INTEGER_UNLIMITED: {
        type: ValidatorType.integerUnlimited,
        method: onIntegerUnlimited
    },
    BOOLEAN: {
        type: ValidatorType.boolean,
        method: onBoolean
    },
    OBJECT: {
        type: ValidatorType.object,
        method: onObject
    },
    ITEM_LIST: {
        type: ValidatorType.itemList,
        method: onItemList
    },
    FUNC: {
        type: ValidatorType.function,
        method: onFunction
    },
    FUNC_WITH_X_ARGUMENTS: ɵ11,
    FUNC_WITH_X_AND_MORE_ARGUMENTS: ɵ12,
    ONE_OF_CAN: ɵ13,
    ONE_OF_MUST: ɵ14,
};
class AdapterValidatedMethodData {
    /**
     * @param {?} context
     */
    constructor(context) {
        this.context = context;
        this.commonErrors = [];
        this.isValid = true;
        this.errors = [];
        this.params = {};
        this.checkContext();
    }
    /**
     * @return {?}
     */
    checkContext() {
        if (!this.context || typeof this.context !== 'object') {
            this.setCommonError(`context is not an object`);
        }
    }
    /**
     * @return {?}
     */
    setValidity() {
        this.errors = Object.keys(this.params).reduce((acc, key) => [
            ...acc, ...this.params[key].errors
        ], this.commonErrors);
        this.isValid = !this.errors.length;
    }
    /**
     * @param {?} error
     * @return {?}
     */
    setCommonError(error) {
        this.commonErrors.push(error);
        this.errors.push(error);
        this.isValid = false;
    }
    /**
     * @param {?} token
     * @param {?} value
     * @return {?}
     */
    setParam(token, value) {
        if (!value.isValid) {
            value.errors = value.errors.map((err) => `"${token}" ${err}`);
        }
        this.params[token] = value;
        this.setValidity();
    }
}
/** @type {?} */
const shouldSkip = ({ type }, value) => type !== ValidatorType.mandatory &&
    type !== ValidatorType.oneOfMust &&
    value === void 0;
/** @type {?} */
const runValidator = (current, validator, context) => {
    const { value, errors } = current;
    if (shouldSkip(validator, value)) {
        return Object.assign({}, current, { isSet: false });
    }
    /** @type {?} */
    const result = validator.method(value, context);
    /** @type {?} */
    const _errors = [...errors, ...result.errors];
    return {
        value: result.value,
        isSet: result.isSet,
        isValid: !_errors.length,
        errors: _errors
    };
};
/** @type {?} */
const validateOne = (context, name, validators) => validators.reduce((acc, validator) => (Object.assign({}, acc, runValidator(acc, validator, context))), (/** @type {?} */ ({
    value: context[name],
    isSet: false,
    isValid: true,
    errors: []
})));
/** @type {?} */
const validate = (context, params) => {
    /** @type {?} */
    const data = new AdapterValidatedMethodData(context);
    if (!data.isValid) {
        return data;
    }
    Object.keys(params).forEach((key) => {
        const { name, validators } = params[key];
        /** @type {?} */
        const parsed = validateOne(context, name, validators);
        data.setParam(name, parsed);
    });
    return data;
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const itemAdapterEmpty = (/** @type {?} */ ({
    data: {},
    element: {}
}));
/** @type {?} */
const noop = () => null;
/** @type {?} */
const ADAPTER_PROPS = () => [
    {
        type: AdapterPropType.Scalar,
        name: 'id',
        value: '',
        permanent: true
    },
    {
        type: AdapterPropType.Scalar,
        name: 'mock',
        value: true,
        permanent: true
    },
    {
        type: AdapterPropType.Scalar,
        name: 'version',
        value: '',
        onDemand: true
    },
    {
        type: AdapterPropType.Scalar,
        name: 'isLoading',
        value: false,
        observable: 'isLoading$'
    },
    {
        type: AdapterPropType.Scalar,
        name: 'loopPending',
        value: false,
        observable: 'loopPending$'
    },
    {
        type: AdapterPropType.Scalar,
        name: 'cyclePending',
        value: false,
        observable: 'cyclePending$'
    },
    {
        type: AdapterPropType.Scalar,
        name: 'firstVisible',
        value: itemAdapterEmpty,
        observable: 'firstVisible$',
        wanted: true
    },
    {
        type: AdapterPropType.Scalar,
        name: 'lastVisible',
        value: itemAdapterEmpty,
        observable: 'lastVisible$',
        wanted: true
    },
    {
        type: AdapterPropType.Scalar,
        name: 'bof',
        value: false,
        observable: 'bof$'
    },
    {
        type: AdapterPropType.Scalar,
        name: 'eof',
        value: false,
        observable: 'eof$'
    },
    {
        type: AdapterPropType.Scalar,
        name: 'itemsCount',
        value: 0,
        onDemand: true
    },
    {
        type: AdapterPropType.Function,
        name: 'reset',
        value: noop
    },
    {
        type: AdapterPropType.Function,
        name: 'reload',
        value: noop
    },
    {
        type: AdapterPropType.Function,
        name: 'append',
        value: noop
    },
    {
        type: AdapterPropType.Function,
        name: 'prepend',
        value: noop
    },
    {
        type: AdapterPropType.Function,
        name: 'check',
        value: noop
    },
    {
        type: AdapterPropType.Function,
        name: 'remove',
        value: noop
    },
    {
        type: AdapterPropType.Function,
        name: 'clip',
        value: noop
    },
    {
        type: AdapterPropType.Function,
        name: 'insert',
        value: noop
    },
    {
        type: AdapterPropType.Function,
        name: 'showLog',
        value: noop
    },
    {
        type: AdapterPropType.Function,
        name: 'fix',
        value: noop
    },
    {
        type: AdapterPropType.Observable,
        name: 'isLoading$',
        value: new Subject()
    },
    {
        type: AdapterPropType.Observable,
        name: 'loopPending$',
        value: new Subject()
    },
    {
        type: AdapterPropType.Observable,
        name: 'cyclePending$',
        value: new Subject()
    },
    {
        type: AdapterPropType.Observable,
        name: 'firstVisible$',
        value: new BehaviorSubject(itemAdapterEmpty)
    },
    {
        type: AdapterPropType.Observable,
        name: 'lastVisible$',
        value: new BehaviorSubject(itemAdapterEmpty)
    },
    {
        type: AdapterPropType.Observable,
        name: 'bof$',
        value: new Subject()
    },
    {
        type: AdapterPropType.Observable,
        name: 'eof$',
        value: new Subject()
    }
];
const { MANDATORY, INTEGER_UNLIMITED, BOOLEAN, OBJECT, ITEM_LIST, FUNC_WITH_X_ARGUMENTS, FUNC_WITH_X_AND_MORE_ARGUMENTS, ONE_OF_MUST, } = VALIDATORS;
/** @type {?} */
const FIX_METHOD_PARAMS = {
    scrollPosition: {
        name: 'scrollPosition',
        validators: [INTEGER_UNLIMITED]
    },
    minIndex: {
        name: 'minIndex',
        validators: [INTEGER_UNLIMITED]
    },
    maxIndex: {
        name: 'maxIndex',
        validators: [INTEGER_UNLIMITED]
    },
    updater: {
        name: 'updater',
        validators: [FUNC_WITH_X_ARGUMENTS(1)]
    }
};
/** @type {?} */
const INSERT_METHOD_PARAMS = {
    items: {
        name: 'items',
        validators: [MANDATORY, ITEM_LIST]
    },
    before: {
        name: 'before',
        validators: [FUNC_WITH_X_ARGUMENTS(1), ONE_OF_MUST(['after'])]
    },
    after: {
        name: 'after',
        validators: [FUNC_WITH_X_ARGUMENTS(1), ONE_OF_MUST(['before'])]
    },
    decrease: {
        name: 'decrease',
        validators: [BOOLEAN]
    }
};
/** @type {?} */
const RESET_METHOD_PARAMS = {
    get: {
        name: 'get',
        validators: [FUNC_WITH_X_AND_MORE_ARGUMENTS(2)]
    },
    settings: {
        name: 'settings',
        validators: [OBJECT]
    },
    devSettings: {
        name: 'devSettings',
        validators: [OBJECT]
    }
};
/** @type {?} */
const ADAPTER_METHODS_PARAMS = {
    FIX: FIX_METHOD_PARAMS,
    INSERT: INSERT_METHOD_PARAMS,
    RESET: RESET_METHOD_PARAMS,
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let instanceCount = 0;
class AdapterContext {
    /**
     * @param {?=} mock
     */
    constructor(mock) {
        /** @type {?} */
        const id = ++instanceCount;
        // props will be reassigned on Scroller instantiation
        ADAPTER_PROPS().forEach(({ name, value, type, permanent }) => Object.defineProperty(this, name, {
            get: () => value,
            configurable: !mock || permanent
        }));
        // set up permanent props
        Object.defineProperty(this, 'id', { get: () => id, configurable: !mock });
        Object.defineProperty(this, 'mock', { get: () => !!mock, configurable: !mock });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Datasource {
    /**
     * @param {?} datasource
     * @param {?=} mockAdapter
     */
    constructor(datasource, mockAdapter) {
        Object.assign((/** @type {?} */ (this)), datasource);
        this.adapter = (/** @type {?} */ ((new AdapterContext(mockAdapter))));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const defaultSettings = {
    adapter: false,
    startIndex: 1,
    minIndex: -Infinity,
    maxIndex: Infinity,
    bufferSize: 5,
    padding: 0.5,
    infinite: false,
    horizontal: false,
    windowViewport: false,
    inverse: false // [experimental] if true, backward padding element will have a priority when filling the viewport in case of lack of items
};
/** @type {?} */
const minSettings = {
    itemSize: 1,
    bufferSize: 1,
    padding: 0.01
};
/** @type {?} */
const defaultDevSettings = {
    debug: false,
    // if true, logging is enabled; need to turn off when release
    immediateLog: true,
    // if false, logging is not immediate and could be done via Workflow.logForce call
    logTime: false,
    // if true, time differences will be logged
    logProcessRun: false,
    // if true, process fire/run info will be logged
    throttle: 40,
    // if > 0, scroll event handling is throttled (ms)
    initDelay: 1,
    // if set, the Workflow initialization will be postponed (ms)
    initWindowDelay: 40,
    // if set and the entire window is scrollable, the Workflow init will be postponed (ms)
    changeOverflow: false,
};
/** @type {?} */
const minDevSettings = {
    throttle: 0,
    initDelay: 0,
    initWindowDelay: 0
};
class Settings {
    /**
     * @param {?} settings
     * @param {?} devSettings
     * @param {?} instanceIndex
     */
    constructor(settings, devSettings, instanceIndex) {
        assignSettings(this, settings || {}, defaultSettings, minSettings);
        assignDevSettings(this, devSettings || {}, defaultDevSettings, minDevSettings);
        this.instanceIndex = instanceIndex;
        this.initializeDelay = this.getInitializeDelay();
        // todo: min/max indexes must be ignored if infinite mode is enabled ??
    }
    /**
     * @return {?}
     */
    getInitializeDelay() {
        /** @type {?} */
        let result = 0;
        if (this.windowViewport && this.initWindowDelay && !('scrollRestoration' in history)) {
            result = this.initWindowDelay;
        }
        if (this.initDelay > 0) {
            result = Math.max(result, this.initDelay);
        }
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Logger {
    /**
     * @param {?} scroller
     * @param {?} version
     */
    constructor(scroller, version) {
        this.logs = [];
        this.logAdapterMethod = (methodName, methodArg, methodSecondArg) => {
            if (!this.debug) {
                return;
            }
            /** @type {?} */
            const params = [
                ...(methodArg ? [methodArg] : []),
                ...(methodSecondArg ? [methodSecondArg] : [])
            ]
                .map((arg) => {
                if (typeof arg === 'function') {
                    return 'func';
                }
                else if (typeof arg !== 'object' || !arg) {
                    return arg;
                }
                else if (Array.isArray(arg)) {
                    return `[of ${arg.length}]`;
                }
                return '{ ' + Object.keys(arg).join(', ') + ' }';
            })
                .join(', ');
            this.log(`adapter: ${methodName}(${params || ''})`);
        };
        const { settings } = scroller;
        this.debug = settings.debug;
        this.immediateLog = settings.immediateLog;
        this.logTime = settings.logTime;
        this.getTime = () => scroller.state && ` // time: ${scroller.state.time}`;
        this.getStat = () => {
            const { buffer, viewport } = scroller;
            /** @type {?} */
            const first = buffer.getFirstVisibleItem();
            /** @type {?} */
            const last = buffer.getLastVisibleItem();
            return 'pos: ' + viewport.scrollPosition + ', ' +
                'size: ' + viewport.getScrollableSize() + ', ' +
                'bwd_p: ' + viewport.paddings.backward.size + ', ' +
                'fwd_p: ' + viewport.paddings.forward.size + ', ' +
                'aver: ' + (buffer.hasItemSize ? buffer.averageSize : 'no') + ', ' +
                'items: ' + buffer.getVisibleItemsCount() + ', ' +
                'range: ' + (first && last ? `[${first.$index}..${last.$index}]` : 'no');
        };
        this.getFetchRange = () => {
            const { firstIndex, lastIndex } = scroller.state.fetch;
            /** @type {?} */
            const hasInterval = firstIndex !== null && lastIndex !== null && !isNaN(firstIndex) && !isNaN(lastIndex);
            return hasInterval ? `[${firstIndex}..${lastIndex}]` : 'no';
        };
        this.getLoop = () => scroller.state.loop;
        this.getLoopNext = () => scroller.state.loopNext;
        this.getWorkflowCycleData = () => `${settings.instanceIndex}-${scroller.state.workflowCycleCount}`;
        this.getScrollPosition = (element) => scroller.routines.getScrollPosition(element);
        this.log(() => `uiScroll Workflow has been started (v${version}, instance ${settings.instanceIndex})`);
    }
    /**
     * @param {?} str
     * @param {?} obj
     * @param {?=} stringify
     * @return {?}
     */
    object(str, obj, stringify) {
        this.log(() => [
            str,
            stringify
                ? JSON.stringify(obj)
                    .replace(/"/g, '')
                    .replace(/(\{|\:|\,)/g, '$1 ')
                    .replace(/(\})/g, ' $1')
                : obj
        ]);
    }
    /**
     * @param {?=} str
     * @return {?}
     */
    stat(str) {
        if (this.debug) {
            /** @type {?} */
            const logStyles = ['color: #888; border: dashed #888 0; border-bottom-width: 0px', 'color: #000; border-width: 0'];
            this.log(() => ['%cstat' + (str ? ` ${str}` : '') + ',%c ' + this.getStat(), ...logStyles]);
        }
    }
    /**
     * @param {?=} str
     * @return {?}
     */
    fetch(str) {
        if (this.debug) {
            /** @type {?} */
            const _text = 'fetch interval' + (str ? ` ${str}` : '');
            /** @type {?} */
            const logStyles = ['color: #888', 'color: #000'];
            this.log(() => [`%c${_text}: %c${this.getFetchRange()}`, ...logStyles]);
        }
    }
    /**
     * @param {?} data
     * @return {?}
     */
    prepareForLog(data) {
        return data instanceof Event
            ? this.getScrollPosition(data.target)
            : data;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    logProcess(data) {
        if (!this.debug) {
            return;
        }
        const { process, status } = data;
        // inner loop start-end log
        /** @type {?} */
        const loopLog = [];
        if (process === Process.init && status === ProcessStatus.next) {
            loopLog.push(`%c---=== loop ${this.getLoopNext()} start`);
        }
        else if (process === Process.end) {
            loopLog.push(`%c---=== loop ${this.getLoop()} done`);
            if (status === ProcessStatus.next) {
                loopLog[0] += `, loop ${this.getLoopNext()} start`;
            }
        }
        if (loopLog.length) {
            this.log(() => [...loopLog, 'color: #006600;']);
        }
    }
    /**
     * @param {?=} start
     * @return {?}
     */
    logCycle(start = true) {
        /** @type {?} */
        const logData = this.getWorkflowCycleData();
        /** @type {?} */
        const border = start ? '1px 0 0 1px' : '0 0 1px 1px';
        /** @type {?} */
        const logStyles = `color: #0000aa; border: solid #555 1px; border-width: ${border}; margin-left: -2px`;
        this.log(() => [`%c   ~~~ WF Cycle ${logData} ${start ? 'STARTED' : 'FINALIZED'} ~~~  `, logStyles]);
    }
    /**
     * @param {?} str
     * @return {?}
     */
    logError(str) {
        if (this.debug) {
            /** @type {?} */
            const logStyles = ['color: #a00;', 'color: #000'];
            this.log(() => ['error:%c' + (str ? ` ${str}` : '') + `%c (loop ${this.getLoopNext()})`, ...logStyles]);
        }
    }
    /**
     * @param {...?} args
     * @return {?}
     */
    log(...args) {
        if (this.debug) {
            if (typeof args[0] === 'function') {
                args = args[0]();
                if (!Array.isArray(args)) {
                    args = [args];
                }
            }
            if (args.every(item => item === void 0)) {
                return;
            }
            if (this.logTime) {
                args = [...args, this.getTime()];
            }
            args = args.map((arg) => this.prepareForLog(arg));
            if (this.immediateLog) {
                console.log.apply(this, (/** @type {?} */ (args)));
            }
            else {
                this.logs.push(args);
            }
        }
    }
    // logNow(...args: any[]) {
    //   const immediateLog = this.immediateLog;
    //   const debug = this.debug;
    //   (this as any).debug = true;
    //   (this as any).immediateLog = true;
    //   this.log.apply(this, args);
    //   (this as any).debug = debug;
    //   (this as any).immediateLog = immediateLog;
    // }
    /**
     * @param {...?} args
     * @return {?}
     */
    logForce(...args) {
        if (this.debug) {
            if (!this.immediateLog && this.logs.length) {
                this.logs.forEach(logArgs => console.log.apply(this, logArgs));
                this.logs = [];
            }
            if (args.length) {
                console.log.apply(this, (/** @type {?} */ (args)));
            }
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Routines {
    /**
     * @param {?} settings
     */
    constructor(settings) {
        this.horizontal = settings.horizontal;
    }
    /**
     * @param {?} element
     * @return {?}
     */
    checkElement(element) {
        if (!element) {
            throw new Error('HTML element is not defined');
        }
    }
    /**
     * @param {?} element
     * @return {?}
     */
    getScrollPosition(element) {
        this.checkElement(element);
        return element[this.horizontal ? 'scrollLeft' : 'scrollTop'];
    }
    /**
     * @param {?} element
     * @param {?} value
     * @return {?}
     */
    setScrollPosition(element, value) {
        this.checkElement(element);
        value = Math.max(0, value);
        element[this.horizontal ? 'scrollLeft' : 'scrollTop'] = value;
    }
    /**
     * @param {?} element
     * @return {?}
     */
    getParams(element) {
        this.checkElement(element);
        if (element.tagName.toLowerCase() === 'body') {
            element = (/** @type {?} */ (element.parentElement));
            return {
                'height': element.clientHeight,
                'width': element.clientWidth,
                'top': element.clientTop,
                'bottom': element.clientTop + element.clientHeight,
                'left': element.clientLeft,
                'right': element.clientLeft + element.clientWidth
            };
        }
        return element.getBoundingClientRect();
    }
    /**
     * @param {?} element
     * @return {?}
     */
    getSize(element) {
        return this.getParams(element)[this.horizontal ? 'width' : 'height'];
    }
    /**
     * @param {?} element
     * @return {?}
     */
    getSizeStyle(element) {
        this.checkElement(element);
        /** @type {?} */
        const size = element.style[this.horizontal ? 'width' : 'height'];
        return parseInt((/** @type {?} */ (size)), 10) || 0;
    }
    /**
     * @param {?} element
     * @param {?} value
     * @return {?}
     */
    setSizeStyle(element, value) {
        this.checkElement(element);
        value = Math.max(0, value);
        element.style[this.horizontal ? 'width' : 'height'] = `${value}px`;
    }
    /**
     * @param {?} params
     * @param {?} direction
     * @param {?=} opposite
     * @return {?}
     */
    getRectEdge(params, direction, opposite) {
        /** @type {?} */
        const forward = !opposite ? Direction.forward : Direction.backward;
        return params[direction === forward ? (this.horizontal ? 'right' : 'bottom') : (this.horizontal ? 'left' : 'top')];
    }
    /**
     * @param {?} element
     * @param {?} direction
     * @param {?=} opposite
     * @return {?}
     */
    getEdge(element, direction, opposite) {
        /** @type {?} */
        const params = this.getParams(element);
        return this.getRectEdge(params, direction, opposite);
    }
    /**
     * @param {?} element
     * @param {?} direction
     * @param {?} relativeElement
     * @param {?} opposite
     * @return {?}
     */
    getEdge2(element, direction, relativeElement, opposite) {
        // vertical only ?
        return element.offsetTop - (relativeElement ? relativeElement.scrollTop : 0) +
            (direction === (!opposite ? Direction.forward : Direction.backward) ? this.getSize(element) : 0);
    }
    /**
     * @param {?} element
     * @return {?}
     */
    hideElement(element) {
        this.checkElement(element);
        element.style.display = 'none';
    }
    /**
     * @param {?} element
     * @return {?}
     */
    getOffset(element) {
        this.checkElement(element);
        return this.horizontal ? element.offsetLeft : element.offsetTop;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Padding {
    /**
     * @param {?} element
     * @param {?} direction
     * @param {?} routines
     */
    constructor(element, direction, routines) {
        this.element = (/** @type {?} */ (element.querySelector(`[data-padding-${direction}]`)));
        this.direction = direction;
        this.routines = routines;
    }
    /**
     * @param {?=} size
     * @return {?}
     */
    reset(size) {
        this.size = size || 0;
    }
    /**
     * @return {?}
     */
    get size() {
        return this.routines.getSizeStyle(this.element);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set size(value) {
        this.routines.setSizeStyle(this.element, Math.round(value));
    }
}
class Paddings {
    /**
     * @param {?} element
     * @param {?} routines
     * @param {?} settings
     */
    constructor(element, routines, settings) {
        this.settings = settings;
        this.forward = new Padding(element, Direction.forward, routines);
        this.backward = new Padding(element, Direction.backward, routines);
    }
    /**
     * @param {?} direction
     * @param {?=} opposite
     * @return {?}
     */
    byDirection(direction, opposite) {
        return direction === Direction.backward
            ? (opposite ? this.forward : this.backward)
            : (opposite ? this.backward : this.forward);
    }
    /**
     * @param {?} viewportSize
     * @param {?} startIndex
     * @return {?}
     */
    reset(viewportSize, startIndex) {
        /** @type {?} */
        const positive = this.getPositiveSize(startIndex, viewportSize);
        /** @type {?} */
        const negative = this.getNegativeSize(startIndex);
        if (this.settings.inverse) {
            this.forward.reset(negative);
            this.backward.reset(positive);
            /** @type {?} */
            const diff = viewportSize - this.backward.size;
            if (diff > 0) {
                this.backward.size += diff;
                this.forward.size -= diff;
            }
        }
        else {
            this.forward.reset(positive);
            this.backward.reset(negative);
            /** @type {?} */
            const diff = viewportSize - this.forward.size;
            if (diff > 0) {
                this.backward.size -= diff;
                this.forward.size += diff;
            }
        }
    }
    /**
     * @param {?} startIndex
     * @param {?} viewportSize
     * @return {?}
     */
    getPositiveSize(startIndex, viewportSize) {
        const { settings } = this;
        /** @type {?} */
        let positiveSize = viewportSize;
        if (isFinite(settings.maxIndex)) {
            positiveSize = (settings.maxIndex - startIndex + 1) * settings.itemSize;
        }
        return positiveSize;
    }
    /**
     * @param {?} startIndex
     * @return {?}
     */
    getNegativeSize(startIndex) {
        const { settings } = this;
        /** @type {?} */
        let negativeSize = 0;
        if (isFinite(settings.minIndex)) {
            negativeSize = (startIndex - settings.minIndex) * settings.itemSize;
        }
        return negativeSize;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Viewport {
    /**
     * @param {?} element
     * @param {?} settings
     * @param {?} routines
     * @param {?} state
     * @param {?} logger
     */
    constructor(element, settings, routines, state, logger) {
        this.element = element;
        this.settings = settings;
        this.routines = routines;
        this.state = state;
        this.logger = logger;
        this.disabled = false;
        if (settings.windowViewport) {
            this.scrollEventElement = (/** @type {?} */ (this.element.ownerDocument));
            this.host = this.scrollEventElement.body;
            this.scrollable = (/** @type {?} */ (this.scrollEventElement.scrollingElement));
        }
        else {
            this.host = (/** @type {?} */ (this.element.parentElement));
            this.scrollEventElement = this.host;
            this.scrollable = (/** @type {?} */ (this.element.parentElement));
        }
        this.paddings = new Paddings(this.element, this.routines, settings);
        if (settings.windowViewport && 'scrollRestoration' in history) {
            history.scrollRestoration = 'manual';
        }
    }
    /**
     * @param {?} scrollPosition
     * @return {?}
     */
    reset(scrollPosition) {
        /** @type {?} */
        let newPosition = 0;
        this.paddings.reset(this.getSize(), this.state.startIndex);
        /** @type {?} */
        const negativeSize = this.paddings.backward.size;
        if (negativeSize) {
            newPosition = negativeSize;
            const { itemSize } = this.settings;
            this.state.bwdPaddingAverageSizeItemsCount = itemSize ? negativeSize / itemSize : 0;
        }
        this.scrollPosition = newPosition;
        this.state.scrollState.reset();
        this.startDelta = 0;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    setPosition(value) {
        /** @type {?} */
        const oldPosition = this.scrollPosition;
        if (oldPosition === value) {
            this.logger.log(() => ['setting scroll position at', value, '[cancelled]']);
            return value;
        }
        this.previousPosition = oldPosition;
        this.routines.setScrollPosition(this.scrollable, value);
        /** @type {?} */
        const position = this.scrollPosition;
        this.logger.log(() => [
            'setting scroll position at', position, ...(position !== value ? [`(${value})`] : [])
        ]);
        return position;
    }
    /**
     * @param {?} oldPos
     * @param {?} newPos
     * @param {?} done
     * @return {?}
     */
    setPositionSafe(oldPos, newPos, done) {
        const { scrollState } = this.state;
        scrollState.syntheticPosition = newPos;
        this.logger.log(() => ['setting scroll position at', oldPos, '(meaning', newPos, 'in next repaint)']);
        this.routines.setScrollPosition(this.scrollable, oldPos);
        scrollState.syntheticFulfill = false;
        scrollState.animationFrameId =
            requestAnimationFrame(() => {
                /** @type {?} */
                const diff = oldPos - this.scrollPosition;
                if (diff > 0) {
                    newPos -= diff;
                    scrollState.syntheticPosition = newPos;
                }
                scrollState.syntheticFulfill = true;
                this.logger.log(() => [
                    'setting scroll position at', newPos,
                    ...(diff > 0 ? [`(${(newPos + diff)} - ${diff})`] : []),
                    '- synthetic fulfillment'
                ]);
                this.routines.setScrollPosition(this.scrollable, newPos);
                done();
            });
    }
    /**
     * @return {?}
     */
    get scrollPosition() {
        return this.routines.getScrollPosition(this.scrollable);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set scrollPosition(value) {
        this.setPosition(value);
    }
    /**
     * @return {?}
     */
    disableScrollForOneLoop() {
        if (this.disabled) {
            return;
        }
        const { style } = this.scrollable;
        if (style.overflowY === 'hidden') {
            return;
        }
        this.disabled = true;
        /** @type {?} */
        const overflow = style.overflowY;
        setTimeout(() => {
            this.disabled = false;
            style.overflowY = overflow;
        });
        style.overflowY = 'hidden';
    }
    /**
     * @return {?}
     */
    getSize() {
        return this.routines.getSize(this.host);
    }
    /**
     * @return {?}
     */
    getScrollableSize() {
        return this.routines.getSize(this.element);
    }
    /**
     * @return {?}
     */
    getBufferPadding() {
        return this.getSize() * this.settings.padding;
    }
    /**
     * @param {?} direction
     * @param {?=} opposite
     * @return {?}
     */
    getEdge(direction, opposite) {
        return this.routines.getEdge(this.host, direction, opposite);
    }
    /**
     * @param {?} element
     * @param {?} direction
     * @param {?=} opposite
     * @return {?}
     */
    getElementEdge(element, direction, opposite) {
        return this.routines.getEdge(element, direction, opposite);
    }
    /**
     * @return {?}
     */
    getOffset() {
        return this.routines.getOffset(this.element);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class ItemCache {
    /**
     * @param {?} item
     */
    constructor(item) {
        this.$index = item.$index;
        this.nodeId = item.nodeId;
        this.data = item.data;
        this.size = item.size;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    changeIndex(value) {
        this.$index = value;
        this.nodeId = String(value);
    }
}
class RecalculateAverage {
    constructor() {
        this.reset();
    }
    /**
     * @return {?}
     */
    reset() {
        this.newItems = [];
        this.oldItems = [];
    }
}
class Cache {
    /**
     * @param {?} itemSize
     * @param {?} logger
     */
    constructor(itemSize, logger) {
        this.averageSizeFloat = itemSize;
        this.averageSize = itemSize;
        this.itemSize = itemSize;
        this.items = new Map();
        this.recalculateAverage = new RecalculateAverage();
        this.reset();
        this.logger = logger;
    }
    /**
     * @return {?}
     */
    reset() {
        this.minIndex = +Infinity;
        this.maxIndex = -Infinity;
        this.items.clear();
        this.averageSizeFloat = this.itemSize;
        this.averageSize = this.itemSize;
        this.recalculateAverage.reset();
    }
    /**
     * @return {?}
     */
    recalculateAverageSize() {
        const { oldItems: { length: oldItemsLength }, newItems: { length: newItemsLength } } = this.recalculateAverage;
        if (!oldItemsLength && !newItemsLength) {
            return false;
        }
        if (oldItemsLength) {
            /** @type {?} */
            const oldItemsSize = this.recalculateAverage.oldItems.reduce((acc, item) => acc + item.size, 0);
            /** @type {?} */
            const newItemsSize = this.recalculateAverage.oldItems.reduce((acc, item) => acc + ((/** @type {?} */ (item.newSize))), 0);
            /** @type {?} */
            const averageSize = this.averageSizeFloat || 0;
            this.averageSizeFloat = averageSize - (oldItemsSize - newItemsSize) / (this.items.size - newItemsLength);
        }
        if (newItemsLength) {
            /** @type {?} */
            const newItemsSize = this.recalculateAverage.newItems.reduce((acc, item) => acc + item.size, 0);
            /** @type {?} */
            const averageSize = this.averageSizeFloat || 0;
            /** @type {?} */
            const averageSizeLength = this.items.size - newItemsLength;
            this.averageSizeFloat = (averageSizeLength * averageSize + newItemsSize) / this.items.size;
        }
        this.averageSize = Math.round(this.averageSizeFloat);
        this.recalculateAverage.reset();
        this.logger.log(() => `average size has been updated: ${this.averageSize}`);
        return true;
    }
    /**
     * @param {?} item
     * @return {?}
     */
    add(item) {
        /** @type {?} */
        let itemCache = this.get(item.$index);
        if (itemCache) {
            itemCache.data = item.data;
            if (itemCache.size !== item.size) {
                this.recalculateAverage.oldItems.push({
                    $index: item.$index,
                    size: itemCache.size,
                    newSize: item.size
                });
                itemCache.size = item.size;
            }
        }
        else {
            itemCache = new ItemCache(item);
            this.items.set(item.$index, itemCache);
            if (this.averageSize !== itemCache.size) {
                this.recalculateAverage.newItems.push({ $index: item.$index, size: itemCache.size });
            }
        }
        if (item.$index < this.minIndex) {
            this.minIndex = item.$index;
        }
        if (item.$index > this.maxIndex) {
            this.maxIndex = item.$index;
        }
        return itemCache;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    getItemSize(index) {
        /** @type {?} */
        const item = this.get(index);
        return item ? item.size : 0;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    get(index) {
        return this.items.get(index);
    }
    /**
     * @return {?}
     */
    get size() {
        return this.items.size;
    }
    /**
     * @param {?} $index
     * @return {?}
     */
    removeItem($index) {
        /** @type {?} */
        const items = new Map();
        /** @type {?} */
        let min = Infinity;
        /** @type {?} */
        let max = -Infinity;
        this.items.delete($index);
        this.items.forEach((item) => {
            if (item.$index < $index) {
                items.set(item.$index, item);
            }
            else {
                // decrement indexes that are greater than $index
                item.changeIndex(item.$index - 1);
                items.set(item.$index - 1, item);
            }
            min = item.$index < min ? item.$index : min;
            max = item.$index > max ? item.$index : max;
        });
        this.items = items;
        this.minIndex = min;
        this.maxIndex = max;
    }
    /**
     * @param {?} index
     * @param {?} count
     * @param {?} decrement
     * @return {?}
     */
    insertItems(index, count, decrement) {
        // we do not insert new items here, we just shift indexes of existed items
        // new items adding will be done by Cache.add execution
        /** @type {?} */
        const items = new Map();
        this.items.forEach((item) => {
            const { $index } = item;
            if ($index < index) {
                if (decrement) {
                    item.changeIndex($index - count);
                }
                items.set(item.$index, item);
            }
            else {
                if (!decrement) {
                    item.changeIndex($index + count);
                }
                items.set(item.$index, item);
            }
            if (item.$index < this.minIndex) {
                this.minIndex = item.$index;
            }
            if (item.$index > this.maxIndex) {
                this.maxIndex = item.$index;
            }
        });
        this.items = items;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Buffer {
    /**
     * @param {?} settings
     * @param {?} startIndex
     * @param {?} logger
     * @param {?=} $items
     */
    constructor(settings, startIndex, logger, $items) {
        this.$items = $items || new BehaviorSubject([]);
        this.bofSource = new Subject();
        this.eofSource = new Subject();
        this.cache = new Cache(settings.itemSize, logger);
        this.minIndexUser = settings.minIndex;
        this.maxIndexUser = settings.maxIndex;
        this.reset();
        this.startIndex = startIndex;
        this.minBufferSize = settings.bufferSize;
        this.logger = logger;
    }
    /**
     * @param {?=} forever
     * @return {?}
     */
    dispose(forever) {
        this.bofSource.complete();
        this.eofSource.complete();
        if (forever) {
            this.$items.complete();
        }
    }
    /**
     * @param {?=} reload
     * @param {?=} startIndex
     * @return {?}
     */
    reset(reload, startIndex) {
        if (reload) {
            this.items.forEach(item => item.hide());
        }
        this.pristine = true;
        this.items = [];
        this.cache.reset();
        this.absMinIndex = this.minIndexUser;
        this.absMaxIndex = this.maxIndexUser;
        if (typeof startIndex !== 'undefined') {
            this.startIndex = startIndex;
        }
        this._bof = false;
        this._eof = false;
        this.pristine = false;
    }
    /**
     * @param {?} items
     * @return {?}
     */
    set items(items) {
        this._items = items;
        this.$items.next(items);
        if (!this.pristine) {
            this.checkBOF();
            this.checkEOF();
        }
    }
    /**
     * @return {?}
     */
    get items() {
        return this._items;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set absMinIndex(value) {
        if (this._absMinIndex !== value) {
            this._absMinIndex = value;
        }
        if (!this.pristine) {
            this.checkBOF();
        }
    }
    /**
     * @return {?}
     */
    get absMinIndex() {
        return this._absMinIndex;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set absMaxIndex(value) {
        if (this._absMaxIndex !== value) {
            this._absMaxIndex = value;
        }
        if (!this.pristine) {
            this.checkEOF();
        }
    }
    /**
     * @return {?}
     */
    get absMaxIndex() {
        return this._absMaxIndex;
    }
    /**
     * @return {?}
     */
    get bof() {
        return this._bof;
    }
    /**
     * @return {?}
     */
    get eof() {
        return this._eof;
    }
    /**
     * @return {?}
     */
    checkBOF() {
        // since bof has no setter, need to call checkBOF() on items and absMinIndex change
        /** @type {?} */
        const bof = this.items.length
            ? (this.items[0].$index === this.absMinIndex)
            : isFinite(this.absMinIndex);
        if (this._bof !== bof) {
            this._bof = bof;
            this.bofSource.next(bof);
        }
    }
    /**
     * @return {?}
     */
    checkEOF() {
        // since eof has no setter, need to call checkEOF() on items and absMaxIndex change
        /** @type {?} */
        const eof = this.items.length
            ? (this.items[this.items.length - 1].$index === this.absMaxIndex)
            : isFinite(this.absMaxIndex);
        if (this._eof !== eof) {
            this._eof = eof;
            this.eofSource.next(eof);
        }
    }
    /**
     * @return {?}
     */
    get size() {
        return this._items.length;
    }
    /**
     * @return {?}
     */
    get averageSize() {
        return this.cache.averageSize;
    }
    /**
     * @return {?}
     */
    get hasItemSize() {
        return this.averageSize !== void 0;
    }
    /**
     * @return {?}
     */
    get minIndex() {
        return isFinite(this.cache.minIndex) ? this.cache.minIndex : this.startIndex;
    }
    /**
     * @return {?}
     */
    get maxIndex() {
        return isFinite(this.cache.maxIndex) ? this.cache.maxIndex : this.startIndex;
    }
    /**
     * @return {?}
     */
    get firstIndex() {
        return this.items.length ? this.items[0].$index : null;
    }
    /**
     * @return {?}
     */
    get lastIndex() {
        return this.items.length ? this.items[this.items.length - 1].$index : null;
    }
    /**
     * @param {?} $index
     * @return {?}
     */
    get($index) {
        return this.items.find((item) => item.$index === $index);
    }
    /**
     * @param {?} items
     * @return {?}
     */
    setItems(items) {
        if (!this.items.length) {
            this.items = [...items];
        }
        else if (this.items[0].$index > items[items.length - 1].$index) {
            this.items = [...items, ...this.items];
        }
        else if (items[0].$index > this.items[this.items.length - 1].$index) {
            this.items = [...this.items, ...items];
        }
        else {
            return false;
        }
        return true;
    }
    /**
     * @param {?} items
     * @return {?}
     */
    append(items) {
        this.items = [...this.items, ...items];
    }
    /**
     * @param {?} items
     * @return {?}
     */
    prepend(items) {
        this.items = [...items, ...this.items];
    }
    /**
     * @param {?} item
     * @return {?}
     */
    removeItem(item) {
        /** @type {?} */
        const items = this.items.filter(({ $index }) => $index !== item.$index);
        items.forEach((_item) => {
            if (_item.$index > item.$index) {
                _item.$index--;
                _item.nodeId = String(_item.$index);
            }
        });
        this.absMaxIndex--; // todo: perhaps we want to reduce absMinIndex in some cases
        this.items = items;
        this.cache.removeItem(item.$index);
    }
    /**
     * @param {?} items
     * @param {?} from
     * @param {?} addition
     * @param {?} decrement
     * @return {?}
     */
    insertItems(items, from, addition, decrement) {
        /** @type {?} */
        const count = items.length;
        /** @type {?} */
        const index = this.items.indexOf(from) + addition;
        /** @type {?} */
        const itemsBefore = this.items.slice(0, index);
        /** @type {?} */
        const itemsAfter = this.items.slice(index);
        if (decrement) {
            itemsBefore.forEach((item) => item.updateIndex(item.$index - count));
        }
        else {
            itemsAfter.forEach((item) => item.updateIndex(item.$index + count));
        }
        /** @type {?} */
        const result = [
            ...itemsBefore,
            ...items,
            ...itemsAfter
        ];
        if (decrement) {
            this.absMinIndex -= count;
        }
        else {
            this.absMaxIndex += count;
        }
        this.items = result;
        this.cache.insertItems(from.$index + addition, count, decrement);
    }
    /**
     * @return {?}
     */
    getFirstVisibleItemIndex() {
        /** @type {?} */
        const length = this.items.length;
        for (let i = 0; i < length; i++) {
            if (!this.items[i].invisible) {
                return i;
            }
        }
        return -1;
    }
    /**
     * @return {?}
     */
    getLastVisibleItemIndex() {
        for (let i = this.items.length - 1; i >= 0; i--) {
            if (!this.items[i].invisible) {
                return i;
            }
        }
        return -1;
    }
    /**
     * @return {?}
     */
    getFirstVisibleItem() {
        /** @type {?} */
        const index = this.getFirstVisibleItemIndex();
        if (index >= 0) {
            return this.items[index];
        }
    }
    /**
     * @return {?}
     */
    getLastVisibleItem() {
        /** @type {?} */
        const index = this.getLastVisibleItemIndex();
        if (index >= 0) {
            return this.items[index];
        }
    }
    /**
     * @param {?} direction
     * @param {?=} opposite
     * @return {?}
     */
    getEdgeVisibleItem(direction, opposite) {
        return direction === (!opposite ? Direction.forward : Direction.backward) ?
            this.getLastVisibleItem() : this.getFirstVisibleItem();
    }
    /**
     * @return {?}
     */
    getVisibleItemsCount() {
        return this.items.reduce((acc, item) => acc + (item.invisible ? 0 : 1), 0);
    }
    /**
     * @param {?} index
     * @return {?}
     */
    getSizeByIndex(index) {
        /** @type {?} */
        const item = this.cache.get(index);
        return item ? item.size : this.averageSize;
    }
    /**
     * @return {?}
     */
    checkAverageSize() {
        return this.cache.recalculateAverageSize();
    }
    /**
     * @param {?=} eof
     * @return {?}
     */
    getIndexToAppend(eof) {
        return (!eof ? (this.size ? this.items[this.size - 1].$index : this.maxIndex) : this.absMaxIndex) + (this.size ? 1 : 0);
    }
    /**
     * @param {?=} bof
     * @return {?}
     */
    getIndexToPrepend(bof) {
        return (!bof ? (this.size ? this.items[0].$index : this.minIndex) : this.absMinIndex) - (this.size ? 1 : 0);
    }
    /**
     * @param {?} eof
     * @param {?} prepend
     * @return {?}
     */
    getIndexToAdd(eof, prepend) {
        return prepend ? this.getIndexToPrepend(eof) : this.getIndexToAppend(eof);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class FetchModel {
    constructor() {
        this.callCount = 0;
        this.reset();
    }
    /**
     * @return {?}
     */
    reset() {
        this._newItemsData = null;
        this.simulate = false;
        this.items = [];
        this.firstIndex = this.firstIndexBuffer = null;
        this.lastIndex = this.lastIndexBuffer = null;
        this.hasAnotherPack = false;
        this.negativeSize = 0;
        this.hasAverageItemSizeChanged = false;
        this.direction = null;
        this.isPrepend = false;
        this.isReplace = false;
    }
    /**
     * @return {?}
     */
    get newItemsData() {
        return this._newItemsData;
    }
    /**
     * @param {?} items
     * @return {?}
     */
    set newItemsData(items) {
        this._newItemsData = items;
        if (items && items.length) {
            this.callCount++;
        }
    }
    /**
     * @return {?}
     */
    get shouldFetch() {
        return !!this.count;
    }
    /**
     * @return {?}
     */
    get hasNewItems() {
        return !!((this._newItemsData && this._newItemsData.length));
    }
    /**
     * @return {?}
     */
    get index() {
        return this.firstIndex;
    }
    /**
     * @return {?}
     */
    get count() {
        return this.firstIndex !== null && this.lastIndex !== null ? this.lastIndex - this.firstIndex + 1 : 0;
    }
    /**
     * @param {?} items
     * @return {?}
     */
    startSimulate(items) {
        this.simulate = true;
        this._newItemsData = items.map(item => item.data);
        this.items = items;
        this.hasAnotherPack = false;
        this.negativeSize = 0;
    }
    /**
     * @return {?}
     */
    stopSimulate() {
        this.simulate = false;
        this.isPrepend = false;
        this.isReplace = false;
    }
    /**
     * @param {?} items
     * @return {?}
     */
    append(items) {
        this.startSimulate(items);
        this.lastIndex = items[items.length - 1].$index;
        this.firstIndex = items[0].$index;
        this.direction = Direction.forward;
    }
    /**
     * @param {?} items
     * @return {?}
     */
    prepend(items) {
        this.startSimulate(items);
        this.lastIndex = items[0].$index;
        this.firstIndex = items[items.length - 1].$index;
        this.direction = Direction.backward;
        this.isPrepend = true;
    }
    /**
     * @param {?} items
     * @return {?}
     */
    replace(items) {
        this.startSimulate(items);
        this.lastIndex = items[0].$index;
        this.firstIndex = items[items.length - 1].$index;
        this.isReplace = true;
    }
    /**
     * @param {?} items
     * @return {?}
     */
    insert(items) {
        this.startSimulate(items);
        this.lastIndex = items[0].$index;
        this.firstIndex = items[items.length - 1].$index;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class ClipModel {
    /**
     * @return {?}
     */
    get force() {
        return this.forceForward || this.forceBackward;
    }
    constructor() {
        this.infinite = false;
        this.noClip = this.infinite;
        this.callCount = 0;
        this.reset();
    }
    /**
     * @return {?}
     */
    reset() {
        this.doClip = false;
        this.forceReset();
    }
    /**
     * @return {?}
     */
    forceReset() {
        this.simulate = false;
        this.forceForward = false;
        this.forceBackward = false;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class RenderModel {
    /**
     * @return {?}
     */
    get noSize() {
        return this.sizeBefore === this.sizeAfter;
    }
    constructor() {
        this.reset();
    }
    /**
     * @return {?}
     */
    reset() {
        this.sizeBefore = 0;
        this.sizeAfter = 0;
        this.fwdPaddingBefore = 0;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class WindowScrollState {
    constructor() {
        this.reset();
    }
    /**
     * @return {?}
     */
    reset() {
        this.delta = 0;
        this.positionToUpdate = 0;
    }
}
class ScrollState {
    constructor() {
        this.window = new WindowScrollState();
        this.reset();
    }
    /**
     * @return {?}
     */
    reset() {
        this.previous = null;
        this.current = null;
        this.scrollTimer = null;
        this.syntheticPosition = null;
        this.syntheticFulfill = false;
        this.animationFrameId = 0;
        this.window.reset();
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class State {
    /**
     * @return {?}
     */
    get time() {
        return Number(new Date()) - this.initTime;
    }
    /**
     * @return {?}
     */
    get loop() {
        return `${this.settings.instanceIndex}-${this.workflowCycleCount}-${this.innerLoopCount}`;
    }
    /**
     * @return {?}
     */
    get loopNext() {
        return `${this.settings.instanceIndex}-${this.workflowCycleCount}-${this.innerLoopCount + 1}`;
    }
    /**
     * @param {?} settings
     * @param {?} version
     * @param {?} logger
     */
    constructor(settings, version, logger) {
        this.settings = settings;
        this.version = version;
        this.logger = logger;
        this.initTime = Number(new Date());
        this.innerLoopCount = 0;
        this.isInitialLoop = false;
        this.workflowCycleCount = 1;
        this.isInitialWorkflowCycle = false;
        this.countDone = 0;
        this.setCurrentStartIndex(settings.startIndex);
        this.fetch = new FetchModel();
        this.clip = new ClipModel();
        this.render = new RenderModel();
        this.bwdPaddingAverageSizeItemsCount = 0;
        this.scrollState = new ScrollState();
    }
    /**
     * @param {?} newStartIndex
     * @return {?}
     */
    setCurrentStartIndex(newStartIndex) {
        const { startIndex, minIndex, maxIndex } = this.settings;
        /** @type {?} */
        let index = Number(newStartIndex);
        if (isNaN(index)) {
            this.logger.log(() => `fallback startIndex to settings.startIndex (${startIndex})`);
            index = startIndex;
        }
        if (index < minIndex) {
            this.logger.log(() => `setting startIndex to settings.minIndex (${minIndex}) because ${index} < ${minIndex}`);
            index = minIndex;
        }
        if (index > maxIndex) {
            this.logger.log(() => `setting startIndex to settings.maxIndex (${maxIndex}) because ${index} > ${maxIndex}`);
            index = maxIndex;
        }
        this.startIndex = index;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const ADAPTER_PROPS_STUB = ADAPTER_PROPS();
/** @type {?} */
const fixScalarWanted = (name, container) => {
    /** @type {?} */
    const scalar = ADAPTER_PROPS_STUB.find(({ observable, wanted }) => wanted && observable === name);
    if (scalar) {
        container[scalar.name] = true;
    }
};
class Adapter {
    /**
     * @param {?} publicContext
     * @param {?} getWorkflow
     * @param {?} logger
     */
    constructor(publicContext, getWorkflow, logger) {
        this.source = {}; // for observables
        // for observables
        this.box = {}; // for scalars over observables
        // for scalars over observables
        this.demand = {}; // for scalars on demand
        // for scalars on demand
        this.wanted = {};
        this.getWorkflow = getWorkflow;
        this.logger = logger;
        // restore original values from the publicContext if present
        /** @type {?} */
        const adapterProps = publicContext
            ? ADAPTER_PROPS_STUB.map(prop => (Object.assign({}, prop, { value: ((/** @type {?} */ (publicContext)))[prop.name] })))
            : ADAPTER_PROPS();
        // Scalar permanent props
        adapterProps
            .filter(({ type, permanent }) => type === AdapterPropType.Scalar && permanent)
            .forEach(({ name, value, wanted }) => Object.defineProperty(this, name, {
            get: () => value
        }));
        // Observable props
        // 1) store original values in "source" container, to avoid extra .get() calls on scalar twins set
        // 2) "wanted" container is bound with scalars; get() updates it
        adapterProps
            .filter(prop => prop.type === AdapterPropType.Observable)
            .forEach(({ name, value, wanted }) => {
            this.source[name] = value;
            Object.defineProperty(this, name, {
                get: () => {
                    fixScalarWanted(name, this.wanted);
                    return this.source[name];
                }
            });
        });
        // Scalar props that have Observable twins
        // 1) scalars should use "box" container
        // 2) "wanted" should be updated on get
        // 3) observables (from "source") are triggered on set
        adapterProps
            .filter(prop => prop.type === AdapterPropType.Scalar && !!prop.observable)
            .forEach(({ type, name, value, observable, wanted }) => {
            if (wanted) {
                this.wanted[name] = false;
            }
            this.box[name] = value;
            Object.defineProperty(this, name, {
                set: (newValue) => {
                    if (newValue !== this.box[name]) {
                        this.box[name] = newValue;
                        this.source[(/** @type {?} */ (observable))].next(newValue);
                    }
                },
                get: () => {
                    if (wanted && !this.wanted[name]) {
                        this.wanted[name] = true;
                    }
                    return this.box[name];
                }
            });
        });
        // Scalar props on-demand
        // these scalars should use "demand" container
        // setting defaults should be overridden on init()
        adapterProps
            .filter(prop => prop.type === AdapterPropType.Scalar && prop.onDemand)
            .forEach(({ name, value }) => {
            this.demand[name] = value;
            Object.defineProperty(this, name, {
                get: () => this.demand[name]
            });
        });
        if (!publicContext) {
            return;
        }
        // augment Adapter public context
        adapterProps
            .forEach(({ name, type }) => Object.defineProperty(publicContext, name, {
            get: () => {
                /** @type {?} */
                const value = ((/** @type {?} */ (this)))[name];
                return type === AdapterPropType.Function ? value.bind(this) : value;
            }
        }));
    }
    /**
     * @return {?}
     */
    get workflow() {
        return this.getWorkflow();
    }
    /**
     * @param {?} state
     * @param {?} buffer
     * @param {?} logger
     * @param {?} dispose$
     * @return {?}
     */
    init(state, buffer, logger, dispose$) {
        /** @type {?} */
        const _get = (name) => {
            switch (name) {
                case 'version':
                    return () => state.version;
                case 'itemsCount':
                    return () => buffer.getVisibleItemsCount();
            }
        };
        ADAPTER_PROPS_STUB // on-demand scalars definition
            .filter(prop => prop.type === AdapterPropType.Scalar && prop.onDemand)
            .forEach(({ name }) => Object.defineProperty(this.demand, name, { get: _get(name) }));
        // logger
        this.logger = logger;
        // others
        this.bof = buffer.bof;
        buffer.bofSource.pipe(takeUntil(dispose$)).subscribe(value => this.bof = value);
        this.eof = buffer.eof;
        buffer.eofSource.pipe(takeUntil(dispose$)).subscribe(value => this.eof = value);
    }
    /**
     * @return {?}
     */
    dispose() { }
    /**
     * @param {?=} datasource
     * @return {?}
     */
    reset(datasource) {
        this.logger.logAdapterMethod('reset', datasource);
        this.workflow.call({
            process: Process.reset,
            status: ProcessStatus.start,
            payload: datasource || null
        });
    }
    /**
     * @param {?=} reloadIndex
     * @return {?}
     */
    reload(reloadIndex) {
        this.logger.logAdapterMethod('reload', reloadIndex);
        this.workflow.call({
            process: Process.reload,
            status: ProcessStatus.start,
            payload: reloadIndex
        });
    }
    /**
     * @param {?} items
     * @param {?=} eof
     * @return {?}
     */
    append(items, eof) {
        this.logger.logAdapterMethod('append', items, eof);
        this.workflow.call({
            process: Process.append,
            status: ProcessStatus.start,
            payload: { items, eof }
        });
    }
    /**
     * @param {?} items
     * @param {?=} bof
     * @return {?}
     */
    prepend(items, bof) {
        this.logger.logAdapterMethod('prepend', items, bof);
        this.workflow.call({
            process: Process.prepend,
            status: ProcessStatus.start,
            payload: { items, bof }
        });
    }
    /**
     * @return {?}
     */
    check() {
        this.logger.logAdapterMethod('check');
        this.workflow.call({
            process: Process.check,
            status: ProcessStatus.start
        });
    }
    /**
     * @param {?} predicate
     * @return {?}
     */
    remove(predicate) {
        this.logger.logAdapterMethod('clip', predicate);
        this.workflow.call({
            process: Process.remove,
            status: ProcessStatus.start,
            payload: predicate
        });
    }
    /**
     * @param {?=} options
     * @return {?}
     */
    clip(options) {
        this.logger.logAdapterMethod('clip', options);
        this.workflow.call({
            process: Process.userClip,
            status: ProcessStatus.start,
            payload: options
        });
    }
    /**
     * @param {?} options
     * @return {?}
     */
    insert(options) {
        this.logger.logAdapterMethod('insert', options);
        this.workflow.call({
            process: Process.insert,
            status: ProcessStatus.start,
            payload: options
        });
    }
    /**
     * @return {?}
     */
    showLog() {
        this.logger.logAdapterMethod('showLog');
        this.logger.logForce();
    }
    /**
     * @param {?} options
     * @return {?}
     */
    fix(options) {
        this.logger.logAdapterMethod('fix', options);
        this.workflow.call({
            process: Process.fix,
            status: ProcessStatus.start,
            payload: options
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
let instanceCount$1 = 0;
class Scroller {
    /**
     * @param {?} element
     * @param {?} datasource
     * @param {?} version
     * @param {?} callWorkflow
     * @param {?=} scroller
     */
    constructor(element, datasource, version, callWorkflow, scroller // for re-initialization
    ) {
        checkDatasource(datasource);
        /** @type {?} */
        const $items = scroller ? scroller.buffer.$items : void 0;
        this.workflow = { call: callWorkflow };
        this.innerLoopSubscriptions = [];
        this.settings = new Settings(datasource.settings, datasource.devSettings, ++instanceCount$1);
        this.logger = new Logger(this, version);
        this.routines = new Routines(this.settings);
        this.state = new State(this.settings, version, this.logger);
        this.buffer = new Buffer(this.settings, this.state.startIndex, this.logger, $items);
        this.viewport = new Viewport(element, this.settings, this.routines, this.state, this.logger);
        this.logger.object('uiScroll settings object', this.settings, true);
        this.initDatasource(datasource, scroller);
    }
    /**
     * @param {?} datasource
     * @param {?=} scroller
     * @return {?}
     */
    initDatasource(datasource, scroller) {
        if (scroller) { // scroller re-instantiating case
            this.datasource = (/** @type {?} */ (datasource));
            this.adapter = scroller.adapter;
            // todo: what about (this.settings.adapter !== scroller.setting.adapter) case?
            return;
        }
        // scroller is being instantiated for the first time
        /** @type {?} */
        const constructed = datasource instanceof Datasource;
        /** @type {?} */
        const mockAdapter = !constructed && !this.settings.adapter;
        if (!constructed) { // datasource as POJO case
            this.datasource = new Datasource(datasource, mockAdapter);
            if (this.settings.adapter) {
                datasource.adapter = this.datasource.adapter;
            }
        }
        else { // instantiated datasource case
            this.datasource = (/** @type {?} */ (datasource));
        }
        /** @type {?} */
        const publicContext = !mockAdapter ? this.datasource.adapter : null;
        this.adapter = new Adapter(publicContext, () => this.workflow, this.logger);
    }
    /**
     * @param {?} dispose$
     * @return {?}
     */
    init(dispose$) {
        this.viewport.reset(0);
        this.logger.stat('initialization');
        this.adapter.init(this.state, this.buffer, this.logger, dispose$);
    }
    /**
     * @return {?}
     */
    bindData() {
        return new Observable((observer) => {
            setTimeout(() => {
                observer.next();
                observer.complete();
            });
        });
    }
    /**
     * @return {?}
     */
    purgeSubscriptions() {
        this.innerLoopSubscriptions.forEach((item) => item.unsubscribe());
        this.innerLoopSubscriptions = [];
    }
    /**
     * @return {?}
     */
    purgeScrollTimers() {
        const { state: { scrollState } } = this;
        if (scrollState.scrollTimer) {
            clearTimeout(scrollState.scrollTimer);
            scrollState.scrollTimer = null;
        }
        if (scrollState.animationFrameId) {
            cancelAnimationFrame(scrollState.animationFrameId);
            scrollState.animationFrameId = 0;
        }
    }
    /**
     * @param {?=} forever
     * @return {?}
     */
    dispose(forever) {
        if (this.adapter && forever) {
            this.adapter.dispose();
        }
        this.buffer.dispose(forever);
        this.purgeSubscriptions();
        this.purgeScrollTimers();
    }
    /**
     * @return {?}
     */
    finalize() {
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Init {
    /**
     * @param {?} scroller
     * @param {?=} process
     * @return {?}
     */
    static run(scroller, process) {
        const { state, workflow, adapter } = scroller;
        /** @type {?} */
        const isInitial = !process || process === Process.reset || process === Process.reload;
        scroller.logger.logCycle(true);
        state.isInitialWorkflowCycle = isInitial;
        state.isInitialLoop = isInitial;
        adapter.cyclePending = true;
        adapter.isLoading = true;
        workflow.call({
            process: Process.init,
            status: ProcessStatus.next,
            payload: { process: process || Process.init }
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Scroll {
    /**
     * @param {?} scroller
     * @param {?} process
     * @param {?=} payload
     * @return {?}
     */
    static run(scroller, process, payload) {
        const { workflow, viewport, state: { scrollState } } = scroller;
        /** @type {?} */
        const position = viewport.scrollPosition;
        if (Scroll.onSynthetic(scroller, position)) {
            return;
        }
        Scroll.onThrottle(scroller, position, () => Scroll.onScroll(scroller, workflow));
    }
    /**
     * @param {?} scroller
     * @param {?} position
     * @return {?}
     */
    static onSynthetic(scroller, position) {
        const { scrollState } = scroller.state;
        /** @type {?} */
        const synthPos = scrollState.syntheticPosition;
        if (synthPos !== null) {
            if (scrollState.syntheticFulfill) {
                scrollState.syntheticPosition = null;
            }
            if (!scrollState.syntheticFulfill || synthPos === position) {
                scroller.logger.log(() => [
                    'skipping scroll', position, `[${scrollState.syntheticFulfill ? '' : 'pre-'}synthetic]`
                ]);
                return true;
            }
            scroller.logger.log(() => [
                'synthetic scroll has been fulfilled:', position, position < synthPos ? '<' : '>', synthPos
            ]);
        }
        return false;
    }
    /**
     * @param {?} scroller
     * @param {?} position
     * @param {?} done
     * @return {?}
     */
    static onThrottle(scroller, position, done) {
        const { state: { scrollState }, settings: { throttle }, logger } = scroller;
        scrollState.current = Scroll.getScrollEvent(scroller, position, scrollState.previous);
        const { direction, time } = scrollState.current;
        /** @type {?} */
        const timeDiff = scrollState.previous ? time - scrollState.previous.time : Infinity;
        /** @type {?} */
        const delta = throttle - timeDiff;
        /** @type {?} */
        const shouldDelay = isFinite(delta) && delta > 0;
        /** @type {?} */
        const alreadyDelayed = !!scrollState.scrollTimer;
        logger.log(() => [
            direction === Direction.backward ? '\u2934' : '\u2935',
            position,
            shouldDelay ? (timeDiff + 'ms') : '0ms',
            shouldDelay ? (alreadyDelayed ? 'delayed' : `/ ${delta}ms delay`) : ''
        ]);
        if (!shouldDelay) {
            if (scrollState.scrollTimer) {
                clearTimeout(scrollState.scrollTimer);
                scrollState.scrollTimer = null;
            }
            done();
            return;
        }
        if (!alreadyDelayed) {
            scrollState.scrollTimer = setTimeout(() => {
                logger.log(() => {
                    /** @type {?} */
                    const curr = Scroll.getScrollEvent(scroller, scroller.viewport.scrollPosition, scrollState.current);
                    return [
                        curr.direction === Direction.backward ? '\u2934' : '\u2935',
                        curr.position,
                        (curr.time - time) + 'ms',
                        'triggered by timer set on',
                        position
                    ];
                });
                scrollState.scrollTimer = null;
                done();
            }, delta);
        }
    }
    /**
     * @param {?} scroller
     * @param {?} position
     * @param {?} previous
     * @return {?}
     */
    static getScrollEvent(scroller, position, previous) {
        /** @type {?} */
        const time = Number(new Date());
        /** @type {?} */
        let direction = Direction.forward;
        const { scrollState } = scroller.state;
        if (previous) {
            if (position === previous.position) {
                direction = previous.direction;
            }
            else if (position < previous.position) {
                direction = Direction.backward;
            }
        }
        return { position, direction, time };
    }
    /**
     * @param {?} scroller
     * @param {?} workflow
     * @return {?}
     */
    static onScroll(scroller, workflow) {
        const { state: { scrollState }, adapter } = scroller;
        scrollState.previous = Object.assign({}, ((/** @type {?} */ (scrollState.current))));
        scrollState.current = null;
        if (adapter.isLoading) {
            scroller.logger.log(() => ['skipping scroll', ((/** @type {?} */ (scrollState.previous))).position, '[pending]']);
            return;
        }
        workflow.call({
            process: Process.scroll,
            status: ProcessStatus.next
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
const { RESET } = ADAPTER_METHODS_PARAMS;
class Reset {
    /**
     * @param {?} scroller
     * @param {?} params
     * @return {?}
     */
    static run(scroller, params) {
        const { datasource, buffer, viewport: { paddings } } = scroller;
        if (params) {
            /** @type {?} */
            const methodData = validate(params, RESET);
            if (!methodData.isValid) {
                scroller.logger.log(() => methodData.errors.join(', '));
                scroller.workflow.call({
                    process: Process.reset,
                    status: ProcessStatus.error,
                    payload: { error: `Wrong argument of the "Adapter.reset" method call` }
                });
                return;
            }
            /** @type {?} */
            const constructed = params instanceof Datasource;
            Object.entries(RESET).forEach(([key, { name }]) => {
                /** @type {?} */
                const param = methodData.params[name];
                if (param.isSet || (constructed && datasource.hasOwnProperty(name))) {
                    ((/** @type {?} */ (datasource)))[name] = param.value;
                }
            });
        }
        buffer.reset(true);
        paddings.backward.reset();
        paddings.forward.reset();
        scroller.workflow.call({
            process: Process.reset,
            status: ProcessStatus.next,
            payload: {
                finalize: scroller.adapter.isLoading,
                datasource
            }
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Reload {
    /**
     * @param {?} scroller
     * @param {?} reloadIndex
     * @return {?}
     */
    static run(scroller, reloadIndex) {
        /** @type {?} */
        const scrollPosition = scroller.viewport.scrollPosition;
        scroller.state.setCurrentStartIndex(reloadIndex);
        scroller.buffer.reset(true, scroller.state.startIndex);
        /** @type {?} */
        const payload = {};
        if (scroller.adapter.isLoading) {
            scroller.purgeScrollTimers();
            payload.finalize = true;
        }
        scroller.viewport.reset(scrollPosition);
        scroller.workflow.call({
            process: Process.reload,
            status: ProcessStatus.next,
            payload
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Item {
    /**
     * @return {?}
     */
    get $index() {
        return this.container.$index;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set $index(value) {
        this.container.$index = value;
    }
    /**
     * @return {?}
     */
    get data() {
        return this.container.data;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set data(value) {
        this.container.data = value;
    }
    /**
     * @return {?}
     */
    get element() {
        return (/** @type {?} */ (this.container.element));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set element(value) {
        this.container.element = value;
    }
    /**
     * @param {?} $index
     * @param {?} data
     * @param {?} routines
     */
    constructor($index, data, routines) {
        this.container = {
            $index,
            data
        };
        this.nodeId = String($index);
        this.routines = routines;
        this.invisible = true;
    }
    /**
     * @return {?}
     */
    setSize() {
        this.size = this.routines.getSize(this.element);
    }
    /**
     * @return {?}
     */
    hide() {
        if (this.element) {
            this.routines.hideElement(this.element);
        }
    }
    /**
     * @param {?} index
     * @return {?}
     */
    updateIndex(index) {
        this.$index = index;
        this.nodeId = String(index);
    }
    /**
     * @return {?}
     */
    get() {
        return this.container;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Append {
    /**
     * @param {?} scroller
     * @param {?} process
     * @param {?} payload
     * @return {?}
     */
    static run(scroller, process, payload) {
        const { workflow } = scroller;
        let { items } = payload;
        items = !Array.isArray(items) ? [items] : items;
        /** @type {?} */
        const prepend = process === Process.prepend;
        /** @type {?} */
        const eof = !!(prepend ? payload.bof : payload.eof);
        if (!items.length) {
            workflow.call({
                process,
                status: ProcessStatus.error,
                payload: { error: `Wrong argument of the "${process}" method call` }
            });
            return;
        }
        // virtual prepend case: shift abs min index and update viewport params
        if ((prepend && eof && !scroller.buffer.bof) ||
            (!prepend && eof && !scroller.buffer.eof)) {
            Append.doVirtualize(scroller, items, prepend);
            workflow.call({
                process,
                status: ProcessStatus.done
            });
            return;
        }
        Append.simulateFetch(scroller, items, eof, prepend);
        workflow.call({
            process,
            status: ProcessStatus.next
        });
    }
    /**
     * @param {?} scroller
     * @param {?} items
     * @param {?} prepend
     * @return {?}
     */
    static doVirtualize(scroller, items, prepend) {
        const { buffer, viewport: { paddings } } = scroller;
        /** @type {?} */
        const bufferToken = prepend ? 'absMinIndex' : 'absMaxIndex';
        if (isFinite(buffer[bufferToken])) {
            /** @type {?} */
            const size = items.length * buffer.averageSize;
            /** @type {?} */
            const padding = prepend ? paddings.backward : paddings.forward;
            buffer[bufferToken] += (prepend ? -1 : 1) * items.length;
            padding.size += size;
            if (prepend) {
                scroller.viewport.scrollPosition += size;
            }
            scroller.logger.log(() => `buffer.${[bufferToken]} value is set to ${buffer[bufferToken]}`);
            scroller.logger.stat(`after virtual ${prepend ? 'prepend' : 'append'}`);
        }
    }
    /**
     * @param {?} scroller
     * @param {?} items
     * @param {?} eof
     * @param {?} prepend
     * @return {?}
     */
    static simulateFetch(scroller, items, eof, prepend) {
        const { buffer, state, state: { fetch } } = scroller;
        /** @type {?} */
        const bufferToken = prepend ? 'absMinIndex' : 'absMaxIndex';
        /** @type {?} */
        let indexToAdd = buffer.getIndexToAdd(eof, prepend);
        /** @type {?} */
        let bufferLimit = buffer[bufferToken];
        /** @type {?} */
        const newItems = [];
        for (let i = 0; i < items.length; i++) {
            /** @type {?} */
            const itemToAdd = new Item(indexToAdd, items[i], scroller.routines);
            if (isFinite(bufferLimit) && ((prepend && indexToAdd < bufferLimit) ||
                (!prepend && indexToAdd > bufferLimit))) {
                bufferLimit += (prepend ? -1 : 1);
            }
            (prepend ? Array.prototype.unshift : Array.prototype.push).apply(newItems, [itemToAdd]);
            // (prepend ? newItems.unshift : newItems.push)(itemToAdd);
            indexToAdd += (prepend ? -1 : 1);
        }
        if (bufferLimit !== buffer[bufferToken]) {
            buffer[bufferToken] = bufferLimit;
            scroller.logger.log(() => `buffer.${bufferToken} value is set to ${buffer[bufferToken]}`);
        }
        (prepend ? fetch.prepend : fetch.append).call(fetch, newItems);
        (prepend ? buffer.prepend : buffer.append).call(buffer, newItems);
        fetch.firstIndexBuffer = buffer.firstIndex !== null ? buffer.firstIndex : indexToAdd;
        fetch.lastIndexBuffer = buffer.lastIndex !== null ? buffer.lastIndex : indexToAdd;
        state.clip.noClip = true;
        return true;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Check {
    /**
     * @param {?} scroller
     * @return {?}
     */
    static run(scroller) {
        const { workflow, buffer, state: { fetch } } = scroller;
        /** @type {?} */
        let min = Infinity;
        /** @type {?} */
        let max = -Infinity;
        buffer.items.forEach(item => {
            /** @type {?} */
            const size = item.size;
            item.setSize();
            if (item.size !== size) {
                buffer.cache.add(item);
                min = Math.min(min, item.$index);
                max = Math.max(max, item.$index);
            }
        });
        if (Number.isFinite(min)) {
            scroller.state.clip.noClip = true;
            fetch.firstIndexBuffer = buffer.firstIndex;
            fetch.lastIndexBuffer = buffer.lastIndex;
            fetch.replace(buffer.items.filter(item => item.$index >= min && item.$index <= max));
        }
        scroller.logger.stat('check');
        workflow.call({
            process: Process.check,
            status: Number.isFinite(min) ? ProcessStatus.next : ProcessStatus.done
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Remove {
    /**
     * @param {?} scroller
     * @param {?} predicate
     * @return {?}
     */
    static run(scroller, predicate) {
        if (!Remove.checkPredicate(predicate)) {
            scroller.workflow.call({
                process: Process.remove,
                status: ProcessStatus.error,
                payload: { error: `Wrong argument of the "Adapter.remove" method call` }
            });
            return;
        }
        scroller.buffer.items.forEach(item => {
            if (predicate(item.get())) {
                item.toRemove = true;
                item.removeDirection = Direction.forward; // will alway increase fwd padding
                scroller.state.clip.doClip = true;
                scroller.state.clip.simulate = true;
            }
        });
        if (!scroller.state.clip.doClip) {
            scroller.workflow.call({
                process: Process.remove,
                status: ProcessStatus.done
            });
            return;
        }
        scroller.workflow.call({
            process: Process.remove,
            status: ProcessStatus.next
        });
    }
    /**
     * @param {?} predicate
     * @return {?}
     */
    static checkPredicate(predicate) {
        if (typeof predicate !== 'function') {
            return false;
        }
        return true;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class UserClip {
    /**
     * @param {?} scroller
     * @param {?=} options
     * @return {?}
     */
    static run(scroller, options) {
        /** @type {?} */
        const _options = UserClip.checkOptions(options);
        scroller.state.clip.forceForward = !_options.backwardOnly;
        scroller.state.clip.forceBackward = !_options.forwardOnly;
        scroller.workflow.call({
            process: Process.userClip,
            status: ProcessStatus.next
        });
    }
    /**
     * @param {?=} options
     * @return {?}
     */
    static checkOptions(options) {
        /** @type {?} */
        const result = {
            forwardOnly: false,
            backwardOnly: false
        };
        if (options !== null && typeof options === 'object') {
            result.backwardOnly = !!options.backwardOnly;
            result.forwardOnly = !!options.forwardOnly;
        }
        return result;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
const { INSERT } = ADAPTER_METHODS_PARAMS;
class Insert {
    /**
     * @param {?} scroller
     * @param {?} options
     * @return {?}
     */
    static run(scroller, options) {
        /** @type {?} */
        const methodData = validate(options, INSERT);
        if (!methodData.isValid) {
            scroller.logger.log(() => methodData.errors.join(', '));
            scroller.workflow.call({
                process: Process.insert,
                status: ProcessStatus.error,
                payload: { error: `Wrong argument of the "Adapter.insert" method call` }
            });
            return;
        }
        /** @type {?} */
        const next = Insert.doInsert(scroller, methodData);
        scroller.workflow.call({
            process: Process.insert,
            status: next ? ProcessStatus.next : ProcessStatus.done
        });
    }
    /**
     * @param {?} scroller
     * @param {?} methodData
     * @return {?}
     */
    static doInsert(scroller, methodData) {
        const { buffer } = scroller;
        const { before, after, items, decrease } = methodData.params;
        /** @type {?} */
        const method = before.isSet ? before.value : after.value;
        /** @type {?} */
        const found = buffer.items.find(item => method(item.get()));
        if (!found) {
            return false;
        }
        /** @type {?} */
        const decrement = decrease.isSet && decrease.value;
        return Insert.simulateFetch(scroller, found, items.value, before.isSet, decrement);
    }
    /**
     * @param {?} scroller
     * @param {?} from
     * @param {?} items
     * @param {?} before
     * @param {?} decrement
     * @return {?}
     */
    static simulateFetch(scroller, from, items, before, decrement) {
        const { buffer, routines, state: { fetch, clip } } = scroller;
        /** @type {?} */
        const bufferLimit = decrement ? buffer.absMinIndex : buffer.absMaxIndex;
        /** @type {?} */
        const addition = before ? 0 : 1;
        /** @type {?} */
        const count = items.length;
        /** @type {?} */
        const itemsToInsert = items.map((item, i) => new Item(from.$index + i + addition - (decrement ? count : 0), item, routines));
        buffer.insertItems(itemsToInsert, from, addition, decrement);
        scroller.logger.log(() => {
            /** @type {?} */
            const newBufferLimit = decrement ? buffer.absMinIndex : buffer.absMaxIndex;
            /** @type {?} */
            const token = decrement ? 'absMinIndex' : 'absMaxIndex';
            return `buffer.${token} value has been changed from ${bufferLimit} to ${newBufferLimit}`;
        });
        fetch.insert(itemsToInsert);
        fetch.firstIndexBuffer = buffer.firstIndex;
        fetch.lastIndexBuffer = buffer.lastIndex;
        clip.noClip = true;
        return true;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
const { FIX } = ADAPTER_METHODS_PARAMS;
class Fix {
    /**
     * @param {?} scroller
     * @param {?} options
     * @return {?}
     */
    static run(scroller, options) {
        const { workflow } = scroller;
        /** @type {?} */
        const params = Fix.checkOptions(scroller, options);
        if (params.length !== Object.keys(options).length) {
            workflow.call({
                process: Process.fix,
                status: ProcessStatus.error,
                payload: { error: `Wrong argument of the "Adapter.fix" method call` }
            });
            return;
        }
        params.forEach((param) => {
            if (typeof param.call !== 'function') {
                return;
            }
            param.call({ scroller, params, value: param.value });
        });
        workflow.call({
            process: Process.fix,
            status: ProcessStatus.done
        });
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    static setScrollPosition({ scroller: { state, viewport }, value }) {
        /** @type {?} */
        let result = (/** @type {?} */ (value));
        if (value === -Infinity) {
            result = 0;
        }
        else if (value === Infinity) {
            result = viewport.getScrollableSize();
        }
        viewport.setPosition(result);
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    static setMinIndex({ scroller: { buffer, settings }, value }) {
        settings.minIndex = (/** @type {?} */ (value));
        buffer.absMinIndex = (/** @type {?} */ (value));
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    static setMaxIndex({ scroller: { buffer, settings }, value }) {
        settings.maxIndex = (/** @type {?} */ (value));
        buffer.absMaxIndex = (/** @type {?} */ (value));
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    static updateItems({ scroller: { buffer }, value }) {
        buffer.items.forEach(item => ((/** @type {?} */ (value)))(item.get()));
    }
    /**
     * @param {?} token
     * @return {?}
     */
    static getCallMethod(token) {
        const { scrollPosition, minIndex, maxIndex, updater } = FIX;
        switch (token) {
            case scrollPosition.name:
                return Fix.setScrollPosition;
            case minIndex.name:
                return Fix.setMinIndex;
            case maxIndex.name:
                return Fix.setMaxIndex;
            case updater.name:
                return Fix.updateItems;
        }
        return null;
    }
    /**
     * @param {?} scroller
     * @param {?} options
     * @return {?}
     */
    static checkOptions(scroller, options) {
        if (!options || typeof options !== 'object') {
            return [];
        }
        return Object.keys(FIX).reduce((acc, key) => {
            /** @type {?} */
            const param = FIX[key];
            const { name, validators } = param;
            /** @type {?} */
            const error = `failed: can't set ${name}`;
            if (options.hasOwnProperty(name)) {
                /** @type {?} */
                const parsed = validateOne(options, name, validators);
                if (parsed.isValid) {
                    /** @type {?} */
                    const call = Fix.getCallMethod(name);
                    if (call) {
                        return [...acc, Object.assign({}, param, { value: parsed.value, call })];
                    }
                    else {
                        scroller.logger.log(() => `${error}, call method not found`);
                    }
                }
                else {
                    scroller.logger.log(() => `${error}, ${parsed.errors}`);
                }
            }
            return acc;
        }, []);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Start {
    /**
     * @param {?} scroller
     * @param {?} process
     * @param {?=} payload
     * @return {?}
     */
    static run(scroller, process, payload) {
        const { state, state: { scrollState, fetch, clip, render }, adapter } = scroller;
        /** @type {?} */
        const processToPass = payload && payload.process || process;
        adapter.loopPending = true;
        if (!fetch.simulate) {
            fetch.reset();
        }
        if (!clip.simulate && !clip.force) {
            clip.reset();
        }
        render.reset();
        scroller.workflow.call({
            process: Process.start,
            status: ProcessStatus.next,
            payload: { process: processToPass }
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class PreFetch {
    /**
     * @param {?} scroller
     * @param {?} process
     * @return {?}
     */
    static run(scroller, process) {
        const { workflow, buffer, state: { fetch } } = scroller;
        scroller.state.preFetchPosition = scroller.viewport.scrollPosition;
        fetch.minIndex = buffer.minIndex;
        fetch.averageItemSize = buffer.averageSize || 0;
        // calculate size before start index
        PreFetch.setStartDelta(scroller);
        // set first and last indexes to fetch
        PreFetch.setFetchIndexes(scroller);
        // skip indexes that are in buffer
        PreFetch.skipBufferedItems(scroller);
        if (scroller.settings.infinite) {
            // fill indexes to include buffer if no clip
            PreFetch.checkBufferGaps(scroller);
        }
        // add indexes if there are too few items to fetch (clip padding)
        PreFetch.checkFetchPackSize(scroller);
        // set fetch direction
        PreFetch.setFetchDirection(scroller);
        if (fetch.shouldFetch) {
            scroller.logger.log(() => `going to fetch ${fetch.count} items started from index ${fetch.index}`);
        }
        workflow.call({
            process: Process.preFetch,
            status: fetch.shouldFetch ? ProcessStatus.next : ProcessStatus.done,
            payload: Object.assign({}, (process ? { process } : {}))
        });
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static setStartDelta(scroller) {
        const { buffer, viewport } = scroller;
        viewport.startDelta = 0;
        if (!buffer.hasItemSize) {
            return;
        }
        /** @type {?} */
        const minIndex = isFinite(buffer.absMinIndex) ? buffer.absMinIndex : buffer.minIndex;
        for (let index = minIndex; index < scroller.state.startIndex; index++) {
            /** @type {?} */
            const item = buffer.cache.get(index);
            viewport.startDelta += item ? item.size : buffer.averageSize;
        }
        if (scroller.settings.windowViewport) {
            viewport.startDelta += viewport.getOffset();
        }
        scroller.logger.log(() => `start delta is ${viewport.startDelta}`);
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static setFetchIndexes(scroller) {
        const { state, viewport } = scroller;
        /** @type {?} */
        const paddingDelta = viewport.getBufferPadding();
        /** @type {?} */
        const relativePosition = state.preFetchPosition - viewport.startDelta;
        /** @type {?} */
        const startPosition = relativePosition - paddingDelta;
        /** @type {?} */
        const endPosition = relativePosition + viewport.getSize() + paddingDelta;
        /** @type {?} */
        const firstIndexPosition = PreFetch.setFirstIndexBuffer(scroller, startPosition);
        PreFetch.setLastIndexBuffer(scroller, firstIndexPosition, endPosition);
        scroller.logger.fetch();
    }
    /**
     * @param {?} scroller
     * @param {?} startPosition
     * @return {?}
     */
    static setFirstIndexBuffer(scroller, startPosition) {
        const { state, buffer, state: { fetch } } = scroller;
        /** @type {?} */
        let firstIndex = state.startIndex;
        /** @type {?} */
        let firstIndexPosition = 0;
        if (scroller.state.isInitialLoop) {
            scroller.logger.log(`skipping fetch backward direction [initial loop]`);
        }
        else if (!buffer.hasItemSize) {
            scroller.logger.log(`skipping fetch backward direction [no item size]`);
        }
        else {
            /** @type {?} */
            let position = firstIndexPosition;
            /** @type {?} */
            let index = firstIndex;
            while (1) {
                if (startPosition >= 0) {
                    /** @type {?} */
                    const size = buffer.getSizeByIndex(index);
                    /** @type {?} */
                    const diff = (position + size) - startPosition;
                    if (diff > 0) {
                        firstIndex = index;
                        firstIndexPosition = position;
                        break;
                    }
                    position += size;
                    index++;
                    if (index < buffer.absMinIndex) {
                        break;
                    }
                }
                if (startPosition < 0) {
                    index--;
                    if (index < buffer.absMinIndex) {
                        break;
                    }
                    position -= buffer.getSizeByIndex(index);
                    /** @type {?} */
                    const diff = position - startPosition;
                    firstIndex = index;
                    firstIndexPosition = position;
                    if (diff <= 0) {
                        break;
                    }
                }
            }
        }
        fetch.firstIndex = fetch.firstIndexBuffer = Math.max(firstIndex, buffer.absMinIndex);
        return firstIndexPosition;
    }
    /**
     * @param {?} scroller
     * @param {?} startPosition
     * @param {?} endPosition
     * @return {?}
     */
    static setLastIndexBuffer(scroller, startPosition, endPosition) {
        const { state, buffer, settings, state: { fetch } } = scroller;
        /** @type {?} */
        let lastIndex;
        if (!buffer.hasItemSize) {
            // just to fetch forward bufferSize items if neither averageItemSize nor itemSize are present
            lastIndex = state.startIndex + settings.bufferSize - 1;
            scroller.logger.log(`forcing fetch forward direction [no item size]`);
        }
        else {
            /** @type {?} */
            let index = (/** @type {?} */ (fetch.firstIndexBuffer));
            /** @type {?} */
            let position = startPosition;
            lastIndex = index;
            while (1) {
                lastIndex = index;
                position += buffer.getSizeByIndex(index);
                if (position >= endPosition) {
                    break;
                }
                if (index++ > buffer.absMaxIndex) {
                    break;
                }
            }
        }
        fetch.lastIndex = fetch.lastIndexBuffer = Math.min(lastIndex, buffer.absMaxIndex);
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static skipBufferedItems(scroller) {
        const { buffer } = scroller;
        if (!buffer.size) {
            return;
        }
        const { fetch } = scroller.state;
        /** @type {?} */
        const firstIndex = (/** @type {?} */ (fetch.firstIndex));
        /** @type {?} */
        const lastIndex = (/** @type {?} */ (fetch.lastIndex));
        /** @type {?} */
        const packs = [[]];
        /** @type {?} */
        let p = 0;
        for (let i = firstIndex; i <= lastIndex; i++) {
            if (!buffer.get(i)) {
                packs[p].push(i);
            }
            else if (packs[p].length) {
                packs[++p] = [];
            }
        }
        /** @type {?} */
        let pack = packs[0];
        if (packs[0].length && packs[1] && packs[1].length) {
            fetch.hasAnotherPack = true;
            // todo: need to look for biggest pack in visible area
            // todo: or think about merging two requests in a single Fetch process
            if (packs[1].length >= packs[0].length) {
                pack = packs[1];
            }
        }
        fetch.firstIndex = Math.max(pack[0], buffer.absMinIndex);
        fetch.lastIndex = Math.min(pack[pack.length - 1], buffer.absMaxIndex);
        if (fetch.firstIndex !== firstIndex || fetch.lastIndex !== lastIndex) {
            scroller.logger.fetch('after Buffer flushing');
        }
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static checkBufferGaps(scroller) {
        const { buffer, state: { fetch } } = scroller;
        if (!buffer.size) {
            return;
        }
        /** @type {?} */
        const fetchFirst = (/** @type {?} */ (fetch.firstIndex));
        /** @type {?} */
        const bufferLast = (/** @type {?} */ (buffer.lastIndex));
        if (fetchFirst > bufferLast) {
            fetch.firstIndex = fetch.firstIndexBuffer = bufferLast + 1;
        }
        /** @type {?} */
        const bufferFirst = (/** @type {?} */ (buffer.firstIndex));
        /** @type {?} */
        const fetchLast = (/** @type {?} */ (fetch.lastIndex));
        if (fetchLast < bufferFirst) {
            fetch.lastIndex = fetch.lastIndexBuffer = bufferFirst - 1;
        }
        if (fetch.firstIndex !== fetchFirst || fetch.lastIndex !== fetchLast) {
            scroller.logger.fetch('after Buffer filling (no clip case)');
        }
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static checkFetchPackSize(scroller) {
        const { buffer, state: { fetch } } = scroller;
        if (!fetch.shouldFetch) {
            return;
        }
        /** @type {?} */
        const firstIndex = (/** @type {?} */ (fetch.firstIndex));
        /** @type {?} */
        const lastIndex = (/** @type {?} */ (fetch.lastIndex));
        /** @type {?} */
        const diff = scroller.settings.bufferSize - (lastIndex - firstIndex + 1);
        if (diff <= 0) {
            return;
        }
        if (!buffer.size || lastIndex > buffer.items[0].$index) { // forward
            // forward
            /** @type {?} */
            const newLastIndex = Math.min(lastIndex + diff, buffer.absMaxIndex);
            if (newLastIndex > lastIndex) {
                fetch.lastIndex = fetch.lastIndexBuffer = newLastIndex;
            }
        }
        else {
            /** @type {?} */
            const newFirstIndex = Math.max(firstIndex - diff, buffer.absMinIndex);
            if (newFirstIndex < firstIndex) {
                fetch.firstIndex = fetch.firstIndexBuffer = newFirstIndex;
            }
        }
        if (fetch.firstIndex !== firstIndex || fetch.lastIndex !== lastIndex) {
            scroller.logger.fetch('after bufferSize adjustment');
            PreFetch.skipBufferedItems(scroller);
        }
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static setFetchDirection(scroller) {
        const { buffer, state: { fetch } } = scroller;
        if (fetch.lastIndex) {
            /** @type {?} */
            let direction = Direction.forward;
            if (buffer.size) {
                direction = fetch.lastIndex < buffer.items[0].$index ? Direction.backward : Direction.forward;
            }
            fetch.direction = direction;
            scroller.logger.log(() => `fetch direction is "${direction}"`);
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Fetch {
    /**
     * @param {?} scroller
     * @return {?}
     */
    static run(scroller) {
        const { workflow } = scroller;
        /**
         * @param {?} data
         * @return {?}
         */
        function success(data) {
            scroller.logger.log(() => `resolved ${data.length} items ` +
                `(index = ${scroller.state.fetch.index}, count = ${scroller.state.fetch.count})`);
            scroller.state.fetch.newItemsData = data;
            workflow.call({
                process: Process.fetch,
                status: ProcessStatus.next
            });
        }
        /**
         * @param {?} error
         * @return {?}
         */
        function fail(error) {
            workflow.call({
                process: Process.fetch,
                status: ProcessStatus.error,
                payload: { error }
            });
        }
        /** @type {?} */
        const result = Fetch.get(scroller);
        if (typeof result.subscribe !== 'function') {
            if (!result.isError) {
                success(result.data);
            }
            else {
                fail(result.error);
            }
        }
        else {
            scroller.innerLoopSubscriptions.push(result.subscribe((data) => success(data), (error) => fail(error)));
        }
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static get(scroller) {
        /** @type {?} */
        const _get = (/** @type {?} */ (scroller.datasource.get));
        /** @type {?} */
        let immediateData;
        /** @type {?} */
        let immediateError;
        /** @type {?} */
        let observer;
        /** @type {?} */
        const success = (data) => {
            if (!observer) {
                immediateData = data || null;
                return;
            }
            observer.next(data);
            observer.complete();
        };
        /** @type {?} */
        const reject = (error) => {
            if (!observer) {
                immediateError = error || null;
                return;
            }
            observer.error(error);
        };
        /** @type {?} */
        const result = _get(scroller.state.fetch.index, scroller.state.fetch.count, success, reject);
        if (result && typeof result.then === 'function') { // DatasourceGetPromise
            result.then(success, reject);
        }
        else if (result && typeof result.subscribe === 'function') { // DatasourceGetObservable
            return result; // do not wrap observable
        }
        if (immediateData !== void 0 || immediateError !== void 0) {
            return {
                data: immediateData,
                error: immediateError,
                isError: immediateError !== void 0
            };
        }
        return new Observable((_observer) => {
            observer = _observer;
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class PostFetch {
    /**
     * @param {?} scroller
     * @return {?}
     */
    static run(scroller) {
        const { workflow } = scroller;
        if (PostFetch.setItems(scroller)) {
            PostFetch.setBufferLimits(scroller);
            workflow.call({
                process: Process.postFetch,
                status: scroller.state.fetch.hasNewItems
                    ? ProcessStatus.next
                    : ProcessStatus.done
            });
        }
        else {
            workflow.call({
                process: Process.postFetch,
                status: ProcessStatus.error,
                payload: { error: `Can't set buffer items` }
            });
        }
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static setBufferLimits(scroller) {
        const { buffer, state: { fetch, fetch: { items }, isInitialLoop } } = scroller;
        /** @type {?} */
        const first = (/** @type {?} */ (fetch.firstIndex));
        /** @type {?} */
        const last = (/** @type {?} */ (fetch.lastIndex));
        if (!items.length) {
            if (last < buffer.minIndex || isInitialLoop) {
                buffer.absMinIndex = buffer.minIndex;
            }
            if (first > buffer.maxIndex || isInitialLoop) {
                buffer.absMaxIndex = buffer.maxIndex;
            }
        }
        else {
            /** @type {?} */
            const lastIndex = items.length - 1;
            if (first < items[0].$index) {
                buffer.absMinIndex = items[0].$index;
            }
            if (last > items[lastIndex].$index) {
                buffer.absMaxIndex = items[lastIndex].$index;
            }
        }
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static setItems(scroller) {
        const { buffer, state: { fetch } } = scroller;
        /** @type {?} */
        const items = fetch.newItemsData;
        if (!items || !items.length) { // empty result
            return true;
        }
        // eof/bof case, need to shift fetch index if bof
        /** @type {?} */
        let fetchIndex = (/** @type {?} */ (fetch.index));
        if (items.length < fetch.count) {
            if (scroller.state.isInitialLoop) {
                // let's treat initial poor fetch as startIndex-bof
                fetchIndex = scroller.state.startIndex;
            }
            else if (((/** @type {?} */ (fetch.firstIndex))) < buffer.minIndex) { // normal bof
                fetchIndex = buffer.minIndex - items.length;
            }
        }
        fetch.items = items.map((item, index) => new Item(fetchIndex + index, item, scroller.routines));
        fetch.isPrepend = !!buffer.items.length && buffer.items[0].$index > fetch.items[fetch.items.length - 1].$index;
        return buffer.setItems(fetch.items);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Render {
    /**
     * @param {?} scroller
     * @return {?}
     */
    static run(scroller) {
        const { workflow, state: { clip, render } } = scroller;
        scroller.logger.stat('before new items render');
        scroller.innerLoopSubscriptions.push(scroller.bindData().subscribe(() => {
            if (Render.processElements(scroller)) {
                workflow.call({
                    process: Process.render,
                    status: render.noSize ? ProcessStatus.done : ProcessStatus.next,
                    payload: { noClip: clip.noClip }
                });
            }
            else {
                workflow.call({
                    process: Process.render,
                    status: ProcessStatus.error,
                    payload: { error: `Can't associate item with element` }
                });
            }
        }));
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static processElements(scroller) {
        const { state, state: { fetch, fetch: { items }, render }, viewport, buffer } = scroller;
        /** @type {?} */
        const scrollBeforeRender = scroller.settings.windowViewport && fetch.isPrepend
            ? scroller.viewport.scrollPosition
            : null;
        if (!fetch.isReplace) {
            render.sizeBefore = viewport.getScrollableSize();
            render.fwdPaddingBefore = viewport.paddings.forward.size;
            if (!items.reduce((acc, item) => acc && Render.processElement(scroller, item), true)) {
                return false;
            }
        }
        fetch.hasAverageItemSizeChanged = buffer.checkAverageSize();
        render.sizeAfter = viewport.getScrollableSize();
        if (!render.noSize && scrollBeforeRender !== null) {
            Render.processWindowScrollBackJump(scroller, scrollBeforeRender);
        }
        scroller.logger.stat('after new items render');
        scroller.logger.log(() => render.noSize ? 'viewport size has not been changed' : void 0);
        return true;
    }
    /**
     * @param {?} scroller
     * @param {?} item
     * @return {?}
     */
    static processElement(scroller, item) {
        const { state: { fetch }, viewport, buffer } = scroller;
        /** @type {?} */
        const element = viewport.element.querySelector(`[data-sid="${item.nodeId}"]`);
        if (!element) {
            return false;
        }
        item.element = (/** @type {?} */ (element));
        item.element.style.left = '';
        item.element.style.position = '';
        item.invisible = false;
        item.setSize();
        buffer.cache.add(item);
        if (item.$index < fetch.minIndex) {
            fetch.negativeSize += item.size;
        }
        return true;
    }
    /**
     * @param {?} scroller
     * @param {?} scrollBeforeRender
     * @return {?}
     */
    static processWindowScrollBackJump(scroller, scrollBeforeRender) {
        const { state, state: { scrollState: { window } }, viewport } = scroller;
        // if new items have been rendered in the area that is before current scroll position
        // then this position will be updated silently in case of entire window scrollable
        // so we need to remember the delta and to update scroll position manually right after it is changed silently
        /** @type {?} */
        const inc = scrollBeforeRender >= viewport.paddings.backward.size ? 1 : -1;
        /** @type {?} */
        const delta = inc * Math.abs(state.render.sizeAfter - state.render.sizeBefore);
        /** @type {?} */
        const positionToUpdate = scrollBeforeRender - delta;
        if (delta && positionToUpdate > 0) {
            window.positionToUpdate = positionToUpdate;
            window.delta = delta;
            scroller.logger.log(() => {
                /** @type {?} */
                const token = delta < 0 ? 'reduced' : 'increased';
                return [`next scroll position (if ${positionToUpdate}) should be ${token} by`, Math.abs(delta)];
            });
        }
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Adjust {
    /**
     * @param {?} scroller
     * @return {?}
     */
    static run(scroller) {
        const { workflow, state, viewport } = scroller;
        /** @type {?} */
        const preAdjustPosition = viewport.scrollPosition;
        // padding-elements adjustments
        /** @type {?} */
        const setPaddingsResult = Adjust.setPaddings(scroller);
        if (setPaddingsResult === null) {
            workflow.call({
                process: Process.adjust,
                status: ProcessStatus.error,
                payload: { error: `Can't get visible item` }
            });
            return;
        }
        // scroll position adjustments
        Adjust.fixScrollPosition(scroller, setPaddingsResult, preAdjustPosition);
        // re-set scroll position (if changed) via animation frame
        const { scrollPosition, previousPosition } = viewport;
        if (preAdjustPosition !== scrollPosition && previousPosition !== scrollPosition) {
            viewport.setPositionSafe(previousPosition, scrollPosition, () => workflow.call({
                process: Process.adjust,
                status: ProcessStatus.done
            }));
            return;
        }
        workflow.call({
            process: Process.adjust,
            status: ProcessStatus.done
        });
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static setPaddings(scroller) {
        const { viewport, buffer, state: { fetch }, settings: { inverse } } = scroller;
        /** @type {?} */
        const firstItem = buffer.getFirstVisibleItem();
        /** @type {?} */
        const lastItem = buffer.getLastVisibleItem();
        if (!firstItem || !lastItem) {
            return null;
        }
        /** @type {?} */
        const forwardPadding = viewport.paddings.forward;
        /** @type {?} */
        const backwardPadding = viewport.paddings.backward;
        /** @type {?} */
        const firstIndex = firstItem.$index;
        /** @type {?} */
        const lastIndex = lastItem.$index;
        /** @type {?} */
        const minIndex = isFinite(buffer.absMinIndex) ? buffer.absMinIndex : buffer.minIndex;
        /** @type {?} */
        const maxIndex = isFinite(buffer.absMaxIndex) ? buffer.absMaxIndex : buffer.maxIndex;
        /** @type {?} */
        const hasAverageItemSizeChanged = fetch.hasAverageItemSizeChanged;
        /** @type {?} */
        let index;
        /** @type {?} */
        let bwdSize = 0;
        /** @type {?} */
        let fwdSize = 0;
        /** @type {?} */
        let bwdPaddingAverageSizeItemsCount = 0;
        // new backward padding
        for (index = minIndex; index < firstIndex; index++) {
            /** @type {?} */
            const item = buffer.cache.get(index);
            bwdSize += item ? item.size : buffer.cache.averageSize;
            if (hasAverageItemSizeChanged) {
                bwdPaddingAverageSizeItemsCount += !item ? 1 : 0;
            }
        }
        if (hasAverageItemSizeChanged) {
            for (index = firstIndex; index < ((/** @type {?} */ (fetch.firstIndexBuffer))); index++) {
                bwdPaddingAverageSizeItemsCount += !buffer.cache.get(index) ? 1 : 0;
            }
        }
        // new forward padding
        for (index = lastIndex + 1; index <= maxIndex; index++) {
            /** @type {?} */
            const item = buffer.cache.get(index);
            fwdSize += item ? item.size : buffer.cache.averageSize;
        }
        // lack of items case
        /** @type {?} */
        const bufferSize = viewport.getScrollableSize() - forwardPadding.size - backwardPadding.size;
        /** @type {?} */
        const viewportSizeDiff = viewport.getSize() - (bwdSize + bufferSize + fwdSize);
        if (viewportSizeDiff > 0) {
            if (inverse) {
                bwdSize += viewportSizeDiff;
            }
            else {
                fwdSize += viewportSizeDiff;
            }
            scroller.logger.log(() => inverse ? 'backward' : 'forward' + ` padding will be increased by ${viewportSizeDiff} to fill the viewport`);
        }
        forwardPadding.size = fwdSize;
        backwardPadding.size = bwdSize;
        scroller.logger.stat('after paddings adjustments');
        return bwdPaddingAverageSizeItemsCount;
    }
    /**
     * @param {?} scroller
     * @param {?} bwdPaddingAverageSizeItemsCount
     * @param {?} preAdjustPosition
     * @return {?}
     */
    static fixScrollPosition(scroller, bwdPaddingAverageSizeItemsCount, preAdjustPosition) {
        const { viewport, buffer, state, state: { fetch, fetch: { items } } } = scroller;
        /** @type {?} */
        const newPosition = viewport.scrollPosition;
        /** @type {?} */
        const posDiff = preAdjustPosition - newPosition;
        let { negativeSize } = fetch;
        if (scroller.settings.windowViewport) {
            if (posDiff) {
                /** @type {?} */
                const winState = state.scrollState.window;
                if (newPosition === winState.positionToUpdate) {
                    winState.reset();
                    scroller.logger.log(() => `process window scroll preventive: sum(${newPosition}, ${posDiff})`);
                    Adjust.setScroll(scroller, posDiff);
                    scroller.logger.stat('after scroll position adjustment (window)');
                    return;
                }
            }
        }
        // if backward padding has been changed due to average item size change
        /** @type {?} */
        const bwdAverageItemsCountDiff = fetch.isReplace ? 0 :
            state.bwdPaddingAverageSizeItemsCount - bwdPaddingAverageSizeItemsCount;
        /** @type {?} */
        const hasBwdParamsChanged = bwdPaddingAverageSizeItemsCount > 0 || bwdAverageItemsCountDiff > 0;
        if (fetch.hasAverageItemSizeChanged && hasBwdParamsChanged) {
            /** @type {?} */
            const _bwdPaddingAverageSize = bwdPaddingAverageSizeItemsCount * buffer.averageSize;
            /** @type {?} */
            const bwdPaddingAverageSize = bwdPaddingAverageSizeItemsCount * fetch.averageItemSize;
            /** @type {?} */
            const bwdPaddingAverageSizeDiff = _bwdPaddingAverageSize - bwdPaddingAverageSize;
            /** @type {?} */
            const bwdAverageItemsSizeDiff = bwdAverageItemsCountDiff * fetch.averageItemSize;
            /** @type {?} */
            const bwdDiff = bwdPaddingAverageSizeDiff - bwdAverageItemsSizeDiff;
            /** @type {?} */
            const positionDiff = posDiff + bwdDiff;
            if (positionDiff) {
                if (scroller.settings.changeOverflow) {
                    viewport.disableScrollForOneLoop();
                }
                Adjust.setScroll(scroller, positionDiff);
                scroller.logger.stat('after scroll position adjustment (average)');
            }
            state.bwdPaddingAverageSizeItemsCount = bwdPaddingAverageSizeItemsCount;
        }
        // no negative area items
        if (!items.length || items[0].$index >= fetch.minIndex) {
            return;
        }
        // if scrollable area size has not been changed during this cycle
        if (viewport.getScrollableSize() === state.render.sizeBefore) {
            return;
        }
        // to fill forward padding gap in case of no minIndex
        if (!isFinite(buffer.absMinIndex)) {
            /** @type {?} */
            const fwdPaddingSizeDiff = state.render.fwdPaddingBefore - viewport.paddings.forward.size;
            /** @type {?} */
            const diff = negativeSize - fwdPaddingSizeDiff;
            negativeSize = diff < 0 ? negativeSize : Math.min(negativeSize, diff);
        }
        if (negativeSize > 0) {
            Adjust.setScroll(scroller, negativeSize);
        }
        else if (negativeSize < 0) {
            viewport.paddings.forward.size -= negativeSize;
            viewport.scrollPosition -= negativeSize;
        }
        scroller.logger.stat('after scroll position adjustment (negative)');
    }
    /**
     * @param {?} scroller
     * @param {?} delta
     * @return {?}
     */
    static setScroll(scroller, delta) {
        const { viewport, settings: { inverse } } = scroller;
        /** @type {?} */
        const viewportSize = viewport.getSize();
        /** @type {?} */
        const forwardPadding = viewport.paddings[Direction.forward];
        /** @type {?} */
        const oldPosition = viewport.scrollPosition;
        /** @type {?} */
        const newPosition = Math.round(oldPosition + delta);
        for (let i = 0; i < Adjust.MAX_SCROLL_ADJUSTMENTS_COUNT; i++) {
            viewport.scrollPosition = newPosition;
            /** @type {?} */
            const positionDiff = newPosition - viewport.scrollPosition;
            /** @type {?} */
            const viewportDiff = viewportSize - newPosition;
            /** @type {?} */
            const diff = Math.min(viewportDiff, positionDiff);
            if (!inverse && diff > 0) {
                forwardPadding.size += diff;
            }
            else {
                break;
            }
        }
    }
}
Adjust.MAX_SCROLL_ADJUSTMENTS_COUNT = 10;

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class PreClip {
    /**
     * @param {?} scroller
     * @return {?}
     */
    static run(scroller) {
        PreClip.prepareClip(scroller);
        scroller.workflow.call({
            process: Process.preClip,
            status: ProcessStatus.next,
            payload: { doClip: scroller.state.clip.doClip }
        });
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static prepareClip(scroller) {
        const { state: { fetch, fetch: { direction } } } = scroller;
        if (PreClip.shouldNotClip(scroller)) {
            return;
        }
        /** @type {?} */
        const firstIndex = (/** @type {?} */ (fetch.firstIndexBuffer));
        /** @type {?} */
        const lastIndex = (/** @type {?} */ (fetch.lastIndexBuffer));
        scroller.logger.log(() => `looking for ${direction ? 'anti-' + direction + ' ' : ''}items ` +
            `that are out of [${firstIndex}..${lastIndex}] range`);
        if (PreClip.isBackward(scroller, firstIndex)) {
            PreClip.prepareClipByDirection(scroller, Direction.backward, firstIndex);
        }
        if (PreClip.isForward(scroller, lastIndex)) {
            PreClip.prepareClipByDirection(scroller, Direction.forward, lastIndex);
        }
        if (!scroller.state.clip.doClip) {
            scroller.logger.log(`skipping clip [no items to clip]`);
        }
        return;
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static shouldNotClip(scroller) {
        const { buffer, state } = scroller;
        if (!buffer.size) {
            scroller.logger.log(`skipping clip [empty buffer]`);
            return true;
        }
        if (state.isInitialWorkflowCycle) {
            scroller.logger.log(`skipping clip [initial cycle]`);
            return true;
        }
        return false;
    }
    /**
     * @param {?} scroller
     * @param {?} firstIndex
     * @return {?}
     */
    static isBackward(scroller, firstIndex) {
        const { buffer, state: { clip, fetch } } = scroller;
        if (clip.force) {
            return clip.forceBackward;
        }
        if (fetch.direction !== Direction.backward) {
            if (firstIndex - 1 >= buffer.absMinIndex) {
                return true;
            }
        }
        return false;
    }
    /**
     * @param {?} scroller
     * @param {?} lastIndex
     * @return {?}
     */
    static isForward(scroller, lastIndex) {
        const { buffer, state: { clip, fetch } } = scroller;
        if (clip.force) {
            return clip.forceForward;
        }
        if (fetch.direction !== Direction.forward) {
            if (lastIndex + 1 <= buffer.absMaxIndex) {
                return true;
            }
        }
        return false;
    }
    /**
     * @param {?} scroller
     * @param {?} direction
     * @param {?} edgeIndex
     * @return {?}
     */
    static prepareClipByDirection(scroller, direction, edgeIndex) {
        /** @type {?} */
        const forward = direction === Direction.forward;
        scroller.buffer.items.forEach(item => {
            if ((!forward && item.$index < edgeIndex) ||
                (forward && item.$index > edgeIndex)) {
                item.toRemove = true;
                item.removeDirection = direction;
                scroller.state.clip.doClip = true;
            }
        });
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Clip {
    /**
     * @param {?} scroller
     * @return {?}
     */
    static run(scroller) {
        const { workflow, state: { clip } } = scroller;
        if (clip.doClip) {
            Clip.doClip(scroller);
        }
        else {
            scroller.logger.log(() => 'no clip');
        }
        workflow.call(Object.assign({ process: Process.clip, status: ProcessStatus.next }, (clip.simulate ? { payload: { process: Process.end } } : {})));
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static doClip(scroller) {
        const { buffer, viewport: { paddings }, logger, state: { clip } } = scroller;
        /** @type {?} */
        const clipped = [];
        /** @type {?} */
        const size = { backward: 0, forward: 0 };
        clip.callCount++;
        logger.stat(`before clip (${clip.callCount})`);
        buffer.items = buffer.items.filter(item => {
            if (item.toRemove) {
                item.hide();
                size[item.removeDirection] += item.size;
                /** @type {?} */
                const padding = paddings.byDirection(item.removeDirection);
                padding.size += item.size;
                clipped.push(item.$index);
                if (clip.simulate && !clip.force) {
                    buffer.removeItem(item);
                }
                return false;
            }
            return true;
        });
        logger.log(() => [
            `clipped ${clipped.length} items` +
                (size.backward ? `, +${size.backward} fwd px` : '') +
                (size.forward ? `, +${size.forward} bwd px` : '') +
                `, range: [${clipped[0]}..${clipped[clipped.length - 1]}]`
        ]);
        logger.stat('after clip');
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class End {
    /**
     * @param {?} scroller
     * @param {?} process
     * @param {?=} payload
     * @return {?}
     */
    static run(scroller, process, payload = {}) {
        const { workflow, state, adapter } = scroller;
        const { error } = payload;
        if (!error && process !== Process.reset && process !== Process.reload) {
            // set out params, accessible via Adapter
            End.calculateParams(scroller);
        }
        // explicit interruption for we don't want go through the workflow loop finalizing
        if (((/** @type {?} */ (workflow.call))).interrupted) {
            workflow.call({
                process,
                status: ProcessStatus.done,
                payload
            });
            return;
        }
        // what next? done?
        /** @type {?} */
        const next = End.getNext(scroller, process, error);
        // finalize current workflow (inner) loop
        End.endWorkflowLoop(scroller, next);
        // continue the Workflow synchronously; current cycle could be finalized immediately
        workflow.call({
            process: Process.end,
            status: next ? ProcessStatus.next : ProcessStatus.done,
            payload: { process }
        });
    }
    /**
     * @param {?} scroller
     * @param {?} next
     * @return {?}
     */
    static endWorkflowLoop(scroller, next) {
        const { state, state: { clip }, adapter } = scroller;
        state.countDone++;
        state.isInitialLoop = false;
        state.fetch.stopSimulate();
        clip.noClip = scroller.settings.infinite || (next && clip.simulate);
        clip.forceReset();
        state.lastPosition = scroller.viewport.scrollPosition;
        scroller.purgeSubscriptions();
        adapter.loopPending = false;
        state.innerLoopCount++;
    }
    /**
     * @param {?} scroller
     * @return {?}
     */
    static calculateParams(scroller) {
        const { buffer: { items }, adapter } = scroller;
        // first visible item
        if (adapter.wanted.firstVisible) {
            /** @type {?} */
            const viewportBackwardEdge = scroller.viewport.getEdge(Direction.backward);
            /** @type {?} */
            const firstItem = items.find(item => scroller.viewport.getElementEdge(item.element, Direction.forward) > viewportBackwardEdge);
            if (!firstItem || firstItem.element !== adapter.firstVisible.element) {
                adapter.firstVisible = firstItem ? firstItem.get() : itemAdapterEmpty;
            }
        }
        // last visible item
        if (adapter.wanted.lastVisible) {
            /** @type {?} */
            const viewportForwardEdge = scroller.viewport.getEdge(Direction.forward);
            /** @type {?} */
            let lastItem = null;
            for (let i = items.length - 1; i >= 0; i--) {
                /** @type {?} */
                const edge = scroller.viewport.getElementEdge(items[i].element, Direction.backward);
                if (edge < viewportForwardEdge) {
                    lastItem = items[i];
                    break;
                }
            }
            if (!lastItem || lastItem.element !== adapter.lastVisible.element) {
                adapter.lastVisible = lastItem ? lastItem.get() : itemAdapterEmpty;
            }
        }
    }
    /**
     * @param {?} scroller
     * @param {?} process
     * @param {?} error
     * @return {?}
     */
    static getNext(scroller, process, error) {
        const { state: { clip, fetch, render, scrollState } } = scroller;
        if (error) {
            return false;
        }
        if (process === Process.reset || process === Process.reload) { // Adapter.reload/reset
            return true;
        }
        if (clip.simulate) { // Adapter.remove
            return true;
        }
        if (fetch.simulate && fetch.isReplace) { // Adapter.check (todo: combine with following)
            return true;
        }
        if (fetch.simulate && !render.noSize) { // Adapter.append/prepend/insert affected viewport size
            return true;
        }
        if ( // common inner loop (App start, Scroll, Adapter.clip) accompanied by fetch
        !fetch.simulate &&
            ((fetch.hasNewItems && !render.noSize) || fetch.hasAnotherPack)) {
            return true;
        }
        return false;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
const runStateMachine = ({ input: { process, status, payload = {} }, methods: { run, interrupt, done, onError } }) => {
    if (status === ProcessStatus.error) {
        onError(process, payload);
        if (!process.startsWith('adapter')) {
            run(End)(process, payload);
        }
        return;
    }
    switch (process) {
        case Process.init:
            if (status === ProcessStatus.start) { // App start
                run(Init)();
            }
            if (status === ProcessStatus.next) {
                run(Start)(process, payload);
            }
            break;
        case Process.scroll:
            if (status === ProcessStatus.start) {
                run(Scroll)(process, payload);
            }
            if (status === ProcessStatus.next) {
                run(Init)(process);
            }
            break;
        case Process.reset:
        case Process.reload:
            /** @type {?} */
            const processToRun = process === Process.reset ? Reset : Reload;
            if (status === ProcessStatus.start) { // Adapter reload/reset
                run(processToRun)(payload);
            }
            if (status === ProcessStatus.next) {
                interrupt(Object.assign({ process }, payload));
                if (payload.finalize) {
                    run(End)(process);
                }
                else {
                    run(Init)(process);
                }
            }
            break;
        case Process.append:
            if (status === ProcessStatus.start) {
                run(Append)(process, payload);
            }
            if (status === ProcessStatus.next) {
                run(Init)(process);
            }
            break;
        case Process.prepend:
            if (status === ProcessStatus.start) {
                run(Append)(process, payload);
            }
            if (status === ProcessStatus.next) {
                run(Init)(process);
            }
            break;
        case Process.check:
            if (status === ProcessStatus.start) {
                run(Check)();
            }
            if (status === ProcessStatus.next) {
                run(Init)(process);
            }
            break;
        case Process.remove:
            if (status === ProcessStatus.start) {
                run(Remove)(payload);
            }
            if (status === ProcessStatus.next) {
                run(Init)(process);
            }
            break;
        case Process.userClip:
            if (status === ProcessStatus.start) {
                run(UserClip)(payload);
            }
            if (status === ProcessStatus.next) {
                run(Init)(process);
            }
            break;
        case Process.insert:
            if (status === ProcessStatus.start) {
                run(Insert)(payload);
            }
            if (status === ProcessStatus.next) {
                run(Init)(process);
            }
            break;
        case Process.fix:
            if (status === ProcessStatus.start) {
                run(Fix)(payload);
            }
            if (status === ProcessStatus.next) {
                run(Init)(process);
            }
            break;
        case Process.start:
            if (status === ProcessStatus.next) {
                switch (payload.process) {
                    case Process.append:
                    case Process.prepend:
                    case Process.check:
                    case Process.insert:
                        run(Render)();
                        break;
                    case Process.remove:
                        run(Clip)();
                        break;
                    case Process.userClip:
                        run(PreFetch)(payload.process);
                        break;
                    default:
                        run(PreFetch)();
                }
            }
            break;
        case Process.preFetch:
            switch (payload.process) {
                case Process.userClip:
                    run(PreClip)();
                    break;
                default:
                    if (status === ProcessStatus.next) {
                        run(Fetch)();
                    }
                    if (status === ProcessStatus.done) {
                        run(End)(process);
                    }
            }
            break;
        case Process.fetch:
            if (status === ProcessStatus.next) {
                run(PostFetch)();
            }
            break;
        case Process.postFetch:
            if (status === ProcessStatus.next) {
                run(Render)();
            }
            if (status === ProcessStatus.done) {
                run(End)(process);
            }
            break;
        case Process.render:
            if (status === ProcessStatus.next) {
                if (payload.noClip) {
                    run(Adjust)();
                }
                else {
                    run(PreClip)();
                }
            }
            if (status === ProcessStatus.done) {
                run(End)(process);
            }
            break;
        case Process.preClip:
            if (status === ProcessStatus.next) {
                if (payload.doClip) {
                    run(Clip)();
                }
                else {
                    run(Adjust)();
                }
            }
            break;
        case Process.clip:
            if (status === ProcessStatus.next) {
                if (payload.process === Process.end) {
                    run(End)(process);
                }
                else {
                    run(Adjust)();
                }
            }
            break;
        case Process.adjust:
            if (status === ProcessStatus.done) {
                run(End)(process);
            }
            break;
        case Process.end:
            if (status === ProcessStatus.next) {
                switch (payload.process) {
                    case Process.reset:
                    case Process.reload:
                        done();
                        run(Init)(payload.process);
                        break;
                    default:
                        run(Start)(process);
                }
            }
            else if (status === ProcessStatus.done) {
                done();
            }
            break;
    }
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class Workflow {
    /**
     * @param {?} element
     * @param {?} datasource
     * @param {?} version
     * @param {?} run
     */
    constructor(element, datasource, version, run) {
        this.isInitialized = false;
        this.dispose$ = new Subject();
        this.process$ = new BehaviorSubject((/** @type {?} */ ({
            process: Process.init,
            status: ProcessStatus.start
        })));
        this.propagateChanges = run;
        this.callWorkflow = this.callWorkflow.bind(this);
        this.scroller = new Scroller(element, datasource, version, this.callWorkflow);
        this.cyclesDone = 0;
        this.interruptionCount = 0;
        this.errors = [];
        this.stateMachineMethods = {
            run: this.runProcess(),
            interrupt: this.interrupt.bind(this),
            done: this.done.bind(this),
            onError: this.onError.bind(this)
        };
        if (this.scroller.settings.initializeDelay) {
            setTimeout(() => this.init(), this.scroller.settings.initializeDelay);
        }
        else {
            this.init();
        }
    }
    /**
     * @return {?}
     */
    init() {
        this.scroller.init(this.dispose$);
        this.isInitialized = true;
        // propagate item list to the view
        this.scroller.buffer.$items.pipe(takeUntil(this.dispose$)).subscribe(items => this.propagateChanges(items));
        // run the workflow process
        this.process$.pipe(takeUntil(this.dispose$)).subscribe(this.process.bind(this));
        // set up scroll event listener
        const { scrollEventElement } = this.scroller.viewport;
        /** @type {?} */
        const onScrollHandler = event => this.callWorkflow({
            process: Process.scroll,
            status: ProcessStatus.start,
            payload: { event }
        });
        scrollEventElement.addEventListener('scroll', onScrollHandler);
        this.dispose$.subscribe(() => scrollEventElement.removeEventListener('scroll', onScrollHandler));
    }
    /**
     * @param {?} processSubject
     * @return {?}
     */
    callWorkflow(processSubject) {
        if (!this.isInitialized) {
            return;
        }
        // this.scroller.logger.log(() => {
        //   const { process, status, payload } = processSubject;
        //   return ['%ccall%c', ...['color: #77cc77;', 'color: #000000;'], process, `"${status}"`, ...(payload ? [payload] : [])];
        // });
        this.process$.next(processSubject);
    }
    /**
     * @param {?} data
     * @return {?}
     */
    process(data) {
        const { status, process, payload } = data;
        if (this.scroller.settings.logProcessRun) {
            this.scroller.logger.log(() => [
                '%cfire%c', ...['color: #cc7777;', 'color: #000000;'], process, `"${status}"`, ...(payload ? [payload] : [])
            ]);
        }
        this.scroller.logger.logProcess(data);
        if (process === Process.end) {
            this.scroller.finalize();
        }
        runStateMachine({
            input: data,
            methods: this.stateMachineMethods
        });
    }
    /**
     * @return {?}
     */
    runProcess() {
        return (process) => (...args) => {
            if (this.scroller.settings.logProcessRun) {
                this.scroller.logger.log(() => ['run', process.name, ...args]);
            }
            process.run(this.scroller, ...args);
        };
    }
    /**
     * @param {?} process
     * @param {?} payload
     * @return {?}
     */
    onError(process, payload) {
        /** @type {?} */
        const message = payload && payload.error || '';
        this.errors.push({
            process,
            message,
            time: this.scroller.state.time,
            loop: this.scroller.state.loopNext
        });
        this.scroller.logger.logError(message);
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    interrupt({ process, finalize, datasource }) {
        if (finalize) {
            const { workflow, logger } = this.scroller;
            // we are going to create a new reference for the scroller.workflow object
            // calling the old version of the scroller.workflow by any outstanding async processes will be skipped
            workflow.call = (p) => logger.log('[skip wf call]');
            ((/** @type {?} */ (workflow.call))).interrupted = true;
            this.scroller.workflow = (/** @type {?} */ ({ call: this.callWorkflow }));
            this.interruptionCount++;
            logger.log(() => `workflow had been interrupted by the ${process} process (${this.interruptionCount})`);
        }
        if (datasource) { // Scroller re-initialization case
            this.scroller.logger.log('new Scroller instantiation');
            const { viewport: { element }, state: { version }, workflow: { call } } = this.scroller;
            /** @type {?} */
            const scroller = new Scroller(element, datasource, version, call, this.scroller);
            this.scroller.dispose();
            this.scroller = scroller;
            this.scroller.init(this.dispose$);
        }
    }
    /**
     * @return {?}
     */
    done() {
        const { state, adapter } = this.scroller;
        this.cyclesDone++;
        this.scroller.logger.logCycle(false);
        state.workflowCycleCount = this.cyclesDone + 1;
        state.isInitialWorkflowCycle = false;
        adapter.cyclePending = false;
        adapter.isLoading = false;
        this.finalize();
    }
    /**
     * @return {?}
     */
    dispose() {
        this.dispose$.next();
        this.dispose$.complete();
        this.scroller.dispose(true);
        this.isInitialized = false;
    }
    /**
     * @return {?}
     */
    finalize() {
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/* tslint:disable:component-selector */
class UiScrollComponent {
    /**
     * @param {?} changeDetector
     * @param {?} elementRef
     */
    constructor(changeDetector, elementRef) {
        this.changeDetector = changeDetector;
        this.elementRef = elementRef;
        // the only template variable
        this.items = [];
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.workflow = new Workflow(this.elementRef.nativeElement, this.datasource, this.version, (items) => {
            if (!items.length && !this.items.length) {
                return;
            }
            this.items = items;
            this.changeDetector.markForCheck();
        });
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.workflow.dispose();
    }
}
UiScrollComponent.ɵfac = function UiScrollComponent_Factory(t) { return new (t || UiScrollComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
UiScrollComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: UiScrollComponent, selectors: [["", "ui-scroll", ""]], attrs: _c0, decls: 3, vars: 1, consts: [["data-padding-backward", ""], [3, "position", "left", 4, "ngFor", "ngForOf"], ["data-padding-forward", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function UiScrollComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, UiScrollComponent_div_1_Template, 2, 12, "div", 1);
        ɵngcc0.ɵɵelement(2, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
UiScrollComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiScrollComponent, [{
        type: Component,
        args: [{
                selector: '[ui-scroll]',
                changeDetection: ChangeDetectionStrategy.OnPush,
                template: `
    <div data-padding-backward></div>
    <div
      *ngFor="let item of items"
      [attr.data-sid]="item.nodeId"
      [style.position]="item.invisible ? 'fixed' : null"
      [style.left]="item.invisible ? '-99999px' : null">
      <ng-template
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{
          $implicit: item.data,
          index: item.$index,
          odd: item.$index % 2,
          even: !(item.$index % 2)
      }"></ng-template>
    </div>
    <div data-padding-forward></div>`
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.ElementRef }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var version = '1.6.0';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class UiScrollDirective {
    /**
     * @param {?} templateRef
     * @param {?} viewContainer
     * @param {?} resolver
     */
    constructor(templateRef, viewContainer, resolver) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.resolver = resolver;
    }
    /**
     * @param {?} datasource
     * @return {?}
     */
    set uiScrollOf(datasource) {
        this.datasource = datasource;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const compFactory = this.resolver.resolveComponentFactory(UiScrollComponent);
        /** @type {?} */
        const componentRef = this.viewContainer.createComponent(compFactory, void 0, this.viewContainer.injector);
        componentRef.instance.datasource = this.datasource;
        componentRef.instance.template = this.templateRef;
        componentRef.instance.version = version;
    }
}
UiScrollDirective.ɵfac = function UiScrollDirective_Factory(t) { return new (t || UiScrollDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ComponentFactoryResolver)); };
UiScrollDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: UiScrollDirective, selectors: [["", "uiScroll", "", "uiScrollOf", ""]], inputs: { uiScrollOf: "uiScrollOf" } });
/** @nocollapse */
UiScrollDirective.ctorParameters = () => [
    { type: TemplateRef },
    { type: ViewContainerRef },
    { type: ComponentFactoryResolver }
];
UiScrollDirective.propDecorators = {
    uiScrollOf: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiScrollDirective, [{
        type: Directive,
        args: [{ selector: '[uiScroll][uiScrollOf]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }, { type: ɵngcc0.ViewContainerRef }, { type: ɵngcc0.ComponentFactoryResolver }]; }, { uiScrollOf: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
class UiScrollModule {
}
UiScrollModule.ɵfac = function UiScrollModule_Factory(t) { return new (t || UiScrollModule)(); };
UiScrollModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UiScrollModule });
UiScrollModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [], imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UiScrollModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    UiScrollComponent,
                    UiScrollDirective
                ],
                imports: [CommonModule],
                entryComponents: [UiScrollComponent],
                exports: [UiScrollDirective],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UiScrollModule, { declarations: function () { return [UiScrollComponent, UiScrollDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [UiScrollDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { UiScrollModule, Datasource, UiScrollComponent as ɵa, UiScrollDirective as ɵb };

